// // // // // // import React, { useState, useEffect } from "react";
// // // // // // const StatusChange = ({ booking, updateBooking, accessToken }) => {
// // // // // //   const [leadStatus, setLeadStatus] = useState("");
// // // // // //   const [reason, setReason] = useState(booking.LeadStatusChangeReason || "");
// // // // // //   const [followUpDate, setFollowUpDate] = useState(booking.FollowUpDate || "");
// // // // // //   const [convertedFields, setConvertedFields] = useState({
// // // // // //     dateOfPayment: booking.Converted_dateOfPayment || "",
// // // // // //     depositamount: booking.Converted_depositamount || "",
// // // // // //     method: booking.Converted_method || "",
// // // // // //     collectedBy: booking.Converted_collectedBy || "",
// // // // // //     transactionId: booking.Converted_transactionId || "",
// // // // // //     paidTowards: booking.Converted_paidTowards || "",
// // // // // //   });
// // // // // //   const [initialReason, setInitialReason] = useState(booking.LeadStatusChangeReason || "");
// // // // // //   const [initialFollowUpDate, setInitialFollowUpDate] = useState(booking.FollowUpDate || "");
// // // // // //   const [initialConvertedFields, setInitialConvertedFields] = useState({
// // // // // //     dateOfPayment: booking.Converted_dateOfPayment || "",
// // // // // //     depositamount: booking.Converted_depositamount || "",
// // // // // //     method: booking.Converted_method || "",
// // // // // //     collectedBy: booking.Converted_collectedBy || "",
// // // // // //     transactionId: booking.Converted_transactionId || "",
// // // // // //     paidTowards: booking.Converted_paidTowards || "",
// // // // // //   });
// // // // // //   const [error, setError] = useState("");
// // // // // //   const [justSaved, setJustSaved] = useState(false);
// // // // // //   const [leadStatusOptions, setLeadStatusOptions] = useState([]);
// // // // // //   const [secondaryStatusOptions, setSecondaryStatusOptions] = useState({});
// // // // // //   const [paymentMethods, setPaymentMethods] = useState([]);
// // // // // //   const [showConfirmation, setShowConfirmation] = useState(false);
// // // // // //   const [isLoading, setIsLoading] = useState(false);

// // // // // //   const generateUniqueId = () => {
// // // // // //     const timestamp = Date.now().toString(36);
// // // // // //     const randomPart = Math.random().toString(36).substring(2, 10);
// // // // // //     return `ACVL${timestamp}-${randomPart}`;
// // // // // //   };

// // // // // //   useEffect(() => {
// // // // // //     const fetchStatusOptions = async () => {
// // // // // //       try {
// // // // // //         const response = await fetch("https://salesjet-10097049716.catalystappsail.com/emailtemp", {
// // // // // //           method: "GET",
// // // // // //           headers: {
// // // // // //             "Content-Type": "application/json",
// // // // // //             Authorization: `Bearer ${accessToken}`,
// // // // // //           },
// // // // // //         });

// // // // // //         if (!response.ok) {
// // // // // //           throw new Error("Failed to fetch status options");
// // // // // //         }

// // // // // //         const data = await response.json();
// // // // // //         if (data.status === "success" && data.records) {
// // // // // //           const statusSet = new Set();
// // // // // //           const paymentMethodsSet = new Set();
// // // // // //           data.records.forEach(record => {
// // // // // //             if (record.LeadStatus) {
// // // // // //               statusSet.add(record.LeadStatus);
// // // // // //             }
// // // // // //             if (record.paymentMethods) {
// // // // // //               paymentMethodsSet.add(record.paymentMethods);
// // // // // //             }
// // // // // //           });
// // // // // //           const groupedOptions = {};
// // // // // //           statusSet.forEach(status => {
// // // // // //             groupedOptions[status] = [];
// // // // // //           });
// // // // // //           data.records.forEach(record => {
// // // // // //             const { secondaryStatusOptions: secondaryOption } = record;
// // // // // //             if (secondaryOption) {
// // // // // //               const firstWord = secondaryOption.split("-")[0].trim();
// // // // // //               if (statusSet.has(firstWord)) {
// // // // // //                 const statusKey = firstWord;
// // // // // //                 if (!groupedOptions[statusKey].includes(secondaryOption)) {
// // // // // //                   groupedOptions[statusKey].push(secondaryOption);
// // // // // //                 }
// // // // // //               }
// // // // // //             }
// // // // // //           });
// // // // // //           const sortedStatuses = [...statusSet].sort();
// // // // // //           const sortedPaymentMethods = [...paymentMethodsSet].sort();
// // // // // //           setLeadStatusOptions(sortedStatuses);
// // // // // //           setSecondaryStatusOptions(groupedOptions);
// // // // // //           setPaymentMethods(sortedPaymentMethods);
// // // // // //         } else {
// // // // // //           setError("No status options found in response");
// // // // // //         }
// // // // // //       } catch (error) {
// // // // // //         console.error("Error fetching status options", error);
// // // // // //         setError("Failed to load status options. Please try again.");
// // // // // //       }
// // // // // //     };

// // // // // //     fetchStatusOptions();
// // // // // //   }, [accessToken]);

// // // // // //   useEffect(() => {
// // // // // //     if (justSaved) {
// // // // // //       if (
// // // // // //         booking.Lead_Status === leadStatus &&
// // // // // //         booking.LeadStatusChangeReason === reason &&
// // // // // //         booking.FollowUpDate === followUpDate &&
// // // // // //         (!leadStatus ||
// // // // // //           leadStatus !== "Converted" ||
// // // // // //           (booking.Converted_dateOfPayment === convertedFields.dateOfPayment &&
// // // // // //             booking.Converted_depositamount === convertedFields.depositamount &&
// // // // // //             booking.Converted_method === convertedFields.method &&
// // // // // //             booking.Converted_collectedBy === convertedFields.collectedBy &&
// // // // // //             booking.Converted_transactionId === convertedFields.transactionId &&
// // // // // //             booking.Converted_paidTowards === convertedFields.paidTowards))
// // // // // //       ) {
// // // // // //         setJustSaved(false);
// // // // // //       }
// // // // // //       return;
// // // // // //     }
// // // // // //     setInitialReason(booking.LeadStatusChangeReason || "");
// // // // // //     setInitialFollowUpDate(booking.FollowUpDate || "");
// // // // // //     setInitialConvertedFields({
// // // // // //       dateOfPayment: booking.Converted_dateOfPayment || "",
// // // // // //       depositamount: booking.Converted_depositamount || "",
// // // // // //       method: booking.Converted_method || "",
// // // // // //       collectedBy: booking.Converted_collectedBy || "",
// // // // // //       transactionId: booking.Converted_transactionId || "",
// // // // // //       paidTowards: booking.Converted_paidTowards || "",
// // // // // //     });

// // // // // //     setLeadStatus("");
// // // // // //     setReason(booking.LeadStatusChangeReason || "");
// // // // // //     setFollowUpDate(booking.FollowUpDate || "");
// // // // // //     setConvertedFields({
// // // // // //       dateOfPayment: booking.Converted_dateOfPayment || "",
// // // // // //       depositamount: booking.Converted_depositamount || "",
// // // // // //       method: booking.Converted_method || "",
// // // // // //       collectedBy: booking.Converted_collectedBy || "",
// // // // // //       transactionId: booking.Converted_transactionId || "",
// // // // // //       paidTowards: booking.Converted_paidTowards || "",
// // // // // //     });
// // // // // //     setError("");
// // // // // //   }, [
// // // // // //     booking.LeadStatusChangeReason,
// // // // // //     booking.FollowUpDate,
// // // // // //     booking.Converted_dateOfPayment,
// // // // // //     booking.Converted_depositamount,
// // // // // //     booking.Converted_method,
// // // // // //     booking.Converted_collectedBy,
// // // // // //     booking.Converted_transactionId,
// // // // // //     booking.Converted_paidTowards,
// // // // // //     booking.Lead_Status,
// // // // // //   ]);

// // // // // //   const handleStatusChange = (e) => {
// // // // // //     const newStatus = e.target.value;
// // // // // //     setLeadStatus(newStatus);

// // // // // //     if (!secondaryStatusOptions[newStatus]) {
// // // // // //       setReason("");
// // // // // //     }

// // // // // //     if (newStatus !== "Open") {
// // // // // //       setFollowUpDate("");
// // // // // //     }

// // // // // //     if (newStatus !== "Converted" && booking.Lead_Status !== "Converted") {
// // // // // //       setConvertedFields({
// // // // // //         dateOfPayment: "",
// // // // // //         depositamount: "",
// // // // // //         method: "",
// // // // // //         collectedBy: "",
// // // // // //         transactionId: "",
// // // // // //         paidTowards: "",
// // // // // //       });
// // // // // //     }
// // // // // //   };

// // // // // //   const handleReasonChange = (e) => {
// // // // // //     const newReason = e.target.value;
// // // // // //     setReason(newReason);
// // // // // //   };

// // // // // //   const handleFollowUpDateChange = (e) => {
// // // // // //     setFollowUpDate(e.target.value);
// // // // // //   };

// // // // // //   const handleConvertedFieldChange = (field, value) => {
// // // // // //     const updated = { ...convertedFields, [field]: value };
// // // // // //     setConvertedFields(updated);
// // // // // //   };

// // // // // //   const validateFields = () => {
// // // // // //     if (!leadStatus) {
// // // // // //       return "Lead Status is required";
// // // // // //     }
// // // // // //     const hasReasonOptions = secondaryStatusOptions[leadStatus] && secondaryStatusOptions[leadStatus].length > 0;
// // // // // //     if (hasReasonOptions && !reason) {
// // // // // //       return "Reason is required";
// // // // // //     }
// // // // // //     if (leadStatus === "Open" && !followUpDate) {
// // // // // //       return "Follow Up Date is required";
// // // // // //     }
// // // // // //     if (leadStatus === "Converted" || booking.Lead_Status === "Converted") {
// // // // // //       for (const [key, value] of Object.entries(convertedFields)) {
// // // // // //         if (!value) {
// // // // // //           return `${key.replace(/([A-Z])/g, " $1").trim()} is required`;
// // // // // //         }
// // // // // //       }
// // // // // //     }
// // // // // //     return "";
// // // // // //   };

// // // // // //   const handleSave = async () => {
// // // // // //     const validationError = validateFields();
// // // // // //     if (validationError) {
// // // // // //       setError(validationError);
// // // // // //       return;
// // // // // //     }

// // // // // //     if (leadStatus === "Converted") {
// // // // // //       setShowConfirmation(true);
// // // // // //       return;
// // // // // //     }

// // // // // //     await performSave();
// // // // // //   };

// // // // // //   const performSave = async () => {
// // // // // //     setError("");
// // // // // //     setIsLoading(true);

// // // // // //     if (!booking?.ROWID || !booking?.LeadACVLRecordID) {
// // // // // //       setError("Missing required booking data (ROWID or LeadACVLRecordID).");
// // // // // //       setIsLoading(false);
// // // // // //       return;
// // // // // //     }
// // // // // //     if (leadStatus === "Converted" && !convertedFields?.depositamount) {
// // // // // //       setError("Deposit amount is required for Converted status.");
// // // // // //       setIsLoading(false);
// // // // // //       return;
// // // // // //     }

// // // // // //     const updatedData = [
// // // // // //       {
// // // // // //         ROWID: booking.ROWID,
// // // // // //         Lead_Status: leadStatus,
// // // // // //         LeadStatusChangeReason: reason || "",
// // // // // //         FollowUpDate: leadStatus === "Open" ? followUpDate : "",
// // // // // //         ...(leadStatus === "Converted" && {
// // // // // //           Converted_dateOfPayment: convertedFields.dateOfPayment || "",
// // // // // //           Converted_depositamount: convertedFields.depositamount || "",
// // // // // //           Converted_method: convertedFields.method || "",
// // // // // //           Converted_collectedBy: convertedFields.collectedBy || "",
// // // // // //           Converted_transactionId: convertedFields.transactionId || "",
// // // // // //           Converted_paidTowards: convertedFields.paidTowards || "",
// // // // // //         }),
// // // // // //       },
// // // // // //     ];

// // // // // //     try {
// // // // // //       console.log("Updating leads data:", updatedData);
// // // // // //       const leadsResponse = await fetch("https://salesjet-10097049716.catalystappsail.com/leadsdata", {
// // // // // //         method: "PUT",
// // // // // //         headers: {
// // // // // //           "Content-Type": "application/json",
// // // // // //           Authorization: `Bearer ${accessToken}`,
// // // // // //         },
// // // // // //         body: JSON.stringify(updatedData),
// // // // // //       });

// // // // // //       if (!leadsResponse.ok) {
// // // // // //         const errorText = await leadsResponse.text();
// // // // // //         throw new Error(`Leads data update failed: ${errorText} (Status: ${leadsResponse.status})`);
// // // // // //       }
// // // // // //       console.log("Leads data updated successfully");

// // // // // //       if (leadStatus === "Converted") {
// // // // // //         const recordId = generateUniqueId();
// // // // // //         const Invoicelink = `https://salesjet.allcanadavanlines.com/app/index.html#/estimate/${booking.LeadACVLRecordID}`;

// // // // // //         const bookingData = [
// // // // // //           {
// // // // // //             Lead_ID: booking.LeadProviderLeadId || "",
// // // // // //             Invoicelink,
// // // // // //             Sales_Agent: booking.Sales_Agent || "Unknown",
// // // // // //             Move_Size: booking.Move_Size || "",
// // // // // //             MoveDate: booking.Move_Date || "",
// // // // // //             INVOICE: booking.LeadACVLRecordID,
// // // // // //             Move_From: booking.OriginCity || "",
// // // // // //             Move_To: booking.DestinationCity || "",
// // // // // //             Estimate_No: booking.LeadACVLRecordID,
// // // // // //             Banner: booking.Banner || "",
// // // // // //             Booked_Date: new Date().toISOString(),
// // // // // //             Status: "Received From SalesJet",
// // // // // //             From_Address: booking.FromAddress || "",
// // // // // //             To_Address: booking.ToAddress || "",
// // // // // //             Move_Type: booking.Move_Type || "",
// // // // // //             Customer_Name: booking.Customer_Name || "",
// // // // // //             Email_Address: booking.Email || "",
// // // // // //             Phone_Number: booking.Phone_Number || "",
// // // // // //             Record_ID: recordId,
// // // // // //           },
// // // // // //         ];

// // // // // //         const paymentData = [
// // // // // //           {
// // // // // //             amount: parseFloat(convertedFields.depositamount) || 0,
// // // // // //             collectedBy: convertedFields.collectedBy || "",
// // // // // //             dateofpayment: convertedFields.dateOfPayment || "",
// // // // // //             method: convertedFields.method || "",
// // // // // //             paidTowards: convertedFields.paidTowards || "",
// // // // // //             transactionId: convertedFields.transactionId || "",
// // // // // //             Record_ID: recordId,
// // // // // //             INVOICE: booking.LeadACVLRecordID,
// // // // // //           },
// // // // // //         ];

// // // // // //         const depositAmount = parseFloat(convertedFields.depositamount) || 0;
// // // // // //         if (depositAmount <= 0) {
// // // // // //           throw new Error("Deposit amount must be greater than zero.");
// // // // // //         }

// // // // // //         const confirmBookingPayload = {
// // // // // //           customerEmail: booking.Email,
// // // // // //           DisplayName: booking.Customer_Name,
// // // // // //           invoiceData: {
// // // // // //             BillEmail: {
// // // // // //               Address: booking.Email,
// // // // // //             },
// // // // // //             DocNumber: booking.LeadACVLRecordID,
// // // // // //             TxnDate: new Date().toISOString().split("T")[0],
// // // // // //             DueDate: booking.Move_Date,
// // // // // //             CustomField: [
// // // // // //               {
// // // // // //                 DefinitionId: '1',
// // // // // //                 Name: 'Sales Agent',
// // // // // //                 Type: 'StringType',
// // // // // //                 StringValue: 'Paul1',
// // // // // //               },
// // // // // //             ],
// // // // // //             BillAddr: {
// // // // // //               Line1: booking.FromAddress,
// // // // // //               Country: "CA",
// // // // // //             },
// // // // // //             ShipAddr: {
// // // // // //               Line1: booking.ToAddress,
// // // // // //               Country: "CA",
// // // // // //             },
// // // // // //             CustomerMemo: {
// // // // // //               value: "Receipt deposit for your upcoming move. This will be applied toward your final invoice.",
// // // // // //             },
// // // // // //         GlobalTaxCalculation: "NotApplicable",
// // // // // //             Line: [
// // // // // //               {
// // // // // //                 Id: "1",
// // // // // //                 LineNum: 1,
// // // // // //                 Description: "Deposit Towards Move Booked",
// // // // // //                 Amount: depositAmount,
// // // // // //                 DetailType: "SalesItemLineDetail",
// // // // // //                 SalesItemLineDetail: {
// // // // // //                   ItemRef: { value: "1", name: "Services" },
// // // // // //                   UnitPrice: depositAmount,
// // // // // //                   Qty: 1,
// // // // // //                   ItemAccountRef: { value: "52", name: "Services" },
// // // // // //                 },
// // // // // //               },
// // // // // //             ],
// // // // // //             Deposit: depositAmount,
// // // // // //             DepositToAccountRef: {
// // // // // //               value: "5",
// // // // // //               name: "Undeposited Funds",
// // // // // //             },
// // // // // //           },
// // // // // //         };

// // // // // //         const updateStatusPayload = [
// // // // // //           {
// // // // // //             ROWID: booking.ROWID,
// // // // // //             Status: "Booked",
// // // // // //           },
// // // // // //         ];

// // // // // //         console.log("Sending booking data:", bookingData);
// // // // // //         console.log("Sending payment data:", paymentData);
// // // // // //         console.log("Sending QuickBooks payload:", confirmBookingPayload);
// // // // // //         console.log("Sending status update:", updateStatusPayload);

// // // // // //         const [bookingResponse, paymentResponse, confirmBookingResponse, statusUpdateResponse] = await Promise.all([
// // // // // //           fetch("https://salesjet-10097049716.catalystappsail.com/bookingdata", {
// // // // // //             method: "POST",
// // // // // //             headers: {
// // // // // //               "Content-Type": "application/json",
// // // // // //             },
// // // // // //             body: JSON.stringify(bookingData),
// // // // // //           }).catch((err) => {
// // // // // //             throw new Error(`Booking data API failed: ${err.message}`);
// // // // // //           }),
// // // // // //           fetch("https://salesjet-10097049716.catalystappsail.com/Payment", {
// // // // // //             method: "POST",
// // // // // //             headers: {
// // // // // //               "Content-Type": "application/json",
// // // // // //             },
// // // // // //             body: JSON.stringify(paymentData),
// // // // // //           }).catch((err) => {
// // // // // //             throw new Error(`Payment data API failed: ${err.message}`);
// // // // // //           }),
// // // // // //           fetch("https://salesjet-841904208.catalystserverless.com/server/qb_post/handle-invoice", {
// // // // // //             method: "POST",
// // // // // //             headers: {
// // // // // //               "Content-Type": "application/json",
// // // // // //             },
// // // // // //             body: JSON.stringify(confirmBookingPayload),
// // // // // //           }).catch((err) => {
// // // // // //             throw new Error(`QuickBooks invoice API failed: ${err.message}`);
// // // // // //           }),
// // // // // //           fetch("https://salesjet-10097049716.catalystappsail.com/leadsdata", {
// // // // // //             method: "PUT",
// // // // // //             headers: {
// // // // // //               "Content-Type": "application/json",
// // // // // //               Authorization: `Bearer ${accessToken}`,
// // // // // //             },
// // // // // //             body: JSON.stringify(updateStatusPayload),
// // // // // //           }).catch((err) => {
// // // // // //             throw new Error(`Status update API failed: ${err.message}`);
// // // // // //           }),
// // // // // //         ]);

// // // // // //         if (!bookingResponse.ok) {
// // // // // //           const errorText = await bookingResponse.text();
// // // // // //           throw new Error(`Booking data save failed: ${errorText} (Status: ${bookingResponse.status})`);
// // // // // //         }
// // // // // //         console.log("Booking data saved successfully");

// // // // // //         if (!paymentResponse.ok) {
// // // // // //           const errorText = await paymentResponse.text();
// // // // // //           throw new Error(`Payment data save failed: ${errorText} (Status: ${paymentResponse.status})`);
// // // // // //         }
// // // // // //         console.log("Payment data saved successfully");

// // // // // //         if (!confirmBookingResponse.ok) {
// // // // // //           let errorData = {};
// // // // // //           try {
// // // // // //             errorData = await confirmBookingResponse.json();
// // // // // //           } catch (jsonError) {
// // // // // //             console.error("Failed to parse QuickBooks error:", jsonError);
// // // // // //           }
// // // // // //           throw new Error(
// // // // // //             `QuickBooks invoice failed: ${errorData.Fault?.Error?.[0]?.Message || "Unknown error"} (${
// // // // // //               errorData.Fault?.Error?.[0]?.Detail || "No details"
// // // // // //             }) (Status: ${confirmBookingResponse.status})`
// // // // // //           );
// // // // // //         }
// // // // // //         console.log("QuickBooks invoice created successfully");

// // // // // //         if (!statusUpdateResponse.ok) {
// // // // // //           const errorText = await statusUpdateResponse.text();
// // // // // //           throw new Error(`Status update failed: ${errorText} (Status: ${statusUpdateResponse.status})`);
// // // // // //         }
// // // // // //         console.log("Status updated successfully");

// // // // // //         const additionalFields = {
// // // // // //           LeadStatusChangeReason: reason || "",
// // // // // //           FollowUpDate: leadStatus === "Open" ? followUpDate : "",
// // // // // //           ...(leadStatus === "Converted" || booking.Lead_Status === "Converted"
// // // // // //             ? {
// // // // // //                 Converted_dateOfPayment: convertedFields.dateOfPayment || "",
// // // // // //                 Converted_depositamount: convertedFields.depositamount || "",
// // // // // //                 Converted_method: convertedFields.method || "",
// // // // // //                 Converted_collectedBy: convertedFields.collectedBy || "",
// // // // // //                 Converted_transactionId: convertedFields.transactionId || "",
// // // // // //                 Converted_paidTowards: convertedFields.paidTowards || "",
// // // // // //               }
// // // // // //             : {}),
// // // // // //         };

// // // // // //         updateBooking("Lead_Status", leadStatus, additionalFields);
// // // // // //         updateBooking("Status", "Book Executed");
// // // // // //         setLeadStatus(leadStatus);
// // // // // //         setReason(reason);
// // // // // //         setFollowUpDate(followUpDate);
// // // // // //         setConvertedFields({ ...convertedFields });
// // // // // //         setInitialReason(reason);
// // // // // //         setInitialFollowUpDate(followUpDate);
// // // // // //         setInitialConvertedFields({ ...convertedFields });
// // // // // //         setJustSaved(true);
// // // // // //         setError("");
// // // // // //         console.log("Save completed successfully");
// // // // // //       } else {
// // // // // //         updateBooking("Lead_Status", leadStatus, {
// // // // // //           LeadStatusChangeReason: reason || "",
// // // // // //           FollowUpDate: leadStatus === "Open" ? followUpDate : "",
// // // // // //         });
// // // // // //         setLeadStatus(leadStatus);
// // // // // //         setReason(reason);
// // // // // //         setFollowUpDate(followUpDate);
// // // // // //         setJustSaved(true);
// // // // // //         setError("");
// // // // // //         console.log("Non-Converted status saved successfully");
// // // // // //       }
// // // // // //     } catch (error) {
// // // // // //       console.error("Error in performSave:", error);
// // // // // //       setError(`Failed to save changes: ${error.message}`);
// // // // // //       setLeadStatus("");
// // // // // //       setReason(initialReason);
// // // // // //       setFollowUpDate(initialFollowUpDate);
// // // // // //       setConvertedFields({ ...initialConvertedFields });
// // // // // //       updateBooking("LeadStatusChangeReason", initialReason);
// // // // // //       updateBooking("FollowUpDate", initialFollowUpDate);
// // // // // //       setJustSaved(false);
// // // // // //     } finally {
// // // // // //       setIsLoading(false);
// // // // // //     }
// // // // // //   };

// // // // // //   const handleConfirm = async () => {
// // // // // //     setShowConfirmation(false);
// // // // // //     await performSave();
// // // // // //   };

// // // // // //   const handleCancelConfirmation = () => {
// // // // // //     setShowConfirmation(false);
// // // // // //   };

// // // // // //   const handleCancel = () => {
// // // // // //     setLeadStatus("");
// // // // // //     setReason(initialReason);
// // // // // //     setFollowUpDate(initialFollowUpDate);
// // // // // //     setConvertedFields({ ...initialConvertedFields });
// // // // // //     setError("");
// // // // // //     updateBooking("LeadStatusChangeReason", initialReason);
// // // // // //     updateBooking("FollowUpDate", initialFollowUpDate);
// // // // // //     if (booking.Lead_Status === "Converted") {
// // // // // //       Object.entries(initialConvertedFields).forEach(([key, value]) => {
// // // // // //         updateBooking(`Converted_${key}`, value);
// // // // // //       });
// // // // // //     }
// // // // // //     setJustSaved(false);
// // // // // //   };

// // // // // //   const displayedCurrentStatus = justSaved ? leadStatus : booking.Lead_Status || "None";
// // // // // //   const isStatusFinal = ["Converted"].includes(leadStatus);
// // // // // //   const isCurrentStatusFinal = justSaved
// // // // // //     ? ["Converted"].includes(leadStatus)
// // // // // //     : ["Converted"].includes(booking.Lead_Status);
// // // // // //   const reasonOptionsKey = leadStatus && leadStatus !== (booking.Lead_Status || "None")
// // // // // //     ? leadStatus
// // // // // //     : booking.Lead_Status || "None";

// // // // // //   return (
// // // // // //     <div className="status-change-section p-4" style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "5px" }}>
// // // // // //       {error && <div className="text-red-500 mb-2">{error}</div>}
// // // // // //       {isLoading && (
// // // // // //         <div className="LoadingOverlay">
// // // // // //           <div className="LoadingOverlayContent">
// // // // // //             <div className="Spinner"></div>
// // // // // //             <p>Processing...</p>
// // // // // //           </div>
// // // // // //         </div>
// // // // // //       )}

// // // // // //       <div
// // // // // //         className="mb-4"
// // // // // //         style={{
// // // // // //           padding: "10px",
// // // // // //           display: "flex",
// // // // // //           justifyContent: isCurrentStatusFinal ? "flex-start" : "space-between",
// // // // // //           alignItems: "center",
// // // // // //         }}
// // // // // //       >
// // // // // //         <div className={isCurrentStatusFinal ? "w-full" : "w-1/3"}>
// // // // // //           <strong>Current Status:</strong> {displayedCurrentStatus}
// // // // // //         </div>
// // // // // //         {!isCurrentStatusFinal && (
// // // // // //           <>
// // // // // //             <div className="w-1/6 text-center" style={{ fontSize: "30px" }}>
// // // // // //               <span className="text-2xl">→</span>
// // // // // //             </div>
// // // // // //             <div className="w-1/2">
// // // // // //               {!isStatusFinal && (
// // // // // //                 <div style={{display: "flex"}}>
// // // // // //                   <label htmlFor="lead-status" className="block font-bold">
// // // // // //                     New Lead Status:
// // // // // //                   </label>
// // // // // //                   <select
// // // // // //                     id="lead-status"
// // // // // //                     value={leadStatus}
// // // // // //                     onChange={handleStatusChange}
// // // // // //                     className="border p-2 rounded w-full"
// // // // // //                     required
// // // // // //                   >
// // // // // //                     <option value="">Select Status</option>
// // // // // //                     {leadStatusOptions.map((status) => (
// // // // // //                       <option key={status} value={status}>
// // // // // //                         {status}
// // // // // //                       </option>
// // // // // //                     ))}
// // // // // //                   </select>
// // // // // //                 </div>
// // // // // //               )}
// // // // // //               {isStatusFinal && (
// // // // // //                 <div>
// // // // // //                   <label htmlFor="lead-status" className="block font-bold">
// // // // // //                     New Status:
// // // // // //                   </label>
// // // // // //                   {leadStatus}
// // // // // //                 </div>
// // // // // //               )}
// // // // // //             </div>
// // // // // //           </>
// // // // // //         )}
// // // // // //       </div>

// // // // // //       <hr className="border-gray-300 mb-4" />

// // // // // //       <div
// // // // // //         className="grid grid-cols-2 gap-4 mb-4"
// // // // // //         style={{ padding: "10px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}
// // // // // //       >
// // // // // //         {secondaryStatusOptions[reasonOptionsKey] && secondaryStatusOptions[reasonOptionsKey].length > 0 && (
// // // // // //           <div style={{ display: "flex", flexDirection: "column" }}>
// // // // // //             <label htmlFor="reason" className="block font-bold">
// // // // // //               Reason
// // // // // //             </label>
// // // // // //             <select
// // // // // //               id="reason"
// // // // // //               value={reason}
// // // // // //               onChange={handleReasonChange}
// // // // // //               className="border p-2 rounded w-full"
// // // // // //               style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
// // // // // //               required
// // // // // //             >
// // // // // //               <option value="">Select Reason</option>
// // // // // //               {secondaryStatusOptions[reasonOptionsKey].map((opt) => (
// // // // // //                 <option key={opt} value={opt}>
// // // // // //                   {opt}
// // // // // //                 </option>
// // // // // //               ))}
// // // // // //             </select>
// // // // // //           </div>
// // // // // //         )}
// // // // // //         {(leadStatus === "Open" || (displayedCurrentStatus === "Open" && leadStatus === "")) && (
// // // // // //           <div style={{ display: "flex", flexDirection: "column" }}>
// // // // // //             <label htmlFor="follow-up-date" className="block font-bold">
// // // // // //               Follow Up Date
// // // // // //             </label>
// // // // // //             <input
// // // // // //               id="follow-up-date"
// // // // // //               type="date"
// // // // // //               value={followUpDate}
// // // // // //               onChange={leadStatus === "Open" ? handleFollowUpDateChange : undefined}
// // // // // //               className="border p-2 rounded w-full"
// // // // // //               style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
// // // // // //               required={leadStatus === "Open"}
// // // // // //               readOnly={leadStatus !== "Open"}
// // // // // //             />
// // // // // //           </div>
// // // // // //         )}
// // // // // //       </div>

// // // // // //       {(leadStatus === "Converted" || booking.Lead_Status === "Converted") && (
// // // // // //         <div
// // // // // //           className="converted-fields grid grid-cols-2 gap-4 mb-4"
// // // // // //           style={{ padding: "10px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}
// // // // // //         >
// // // // // //           <div style={{ display: "flex", flexDirection: "column" }}>
// // // // // //             <label className="block font-bold">Date of Payment</label>
// // // // // //             <input
// // // // // //               type="date"
// // // // // //               value={convertedFields.dateOfPayment}
// // // // // //               onChange={(e) => handleConvertedFieldChange("dateOfPayment", e.target.value)}
// // // // // //               className="border p-2 rounded w-full"
// // // // // //               style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
// // // // // //               required
// // // // // //             />
// // // // // //           </div>
// // // // // //           <div style={{ display: "flex", flexDirection: "column" }}>
// // // // // //             <label className="block font-bold">Deposit Amount</label>
// // // // // //             <input
// // // // // //               type="number"
// // // // // //               value={convertedFields.depositamount}
// // // // // //               onChange={(e) => handleConvertedFieldChange("depositamount", e.target.value)}
// // // // // //               className="border p-2 rounded w-full"
// // // // // //               style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
// // // // // //               required
// // // // // //             />
// // // // // //           </div>
// // // // // //           <div style={{ display: "flex", flexDirection: "column" }}>
// // // // // //             <label className="block font-bold">Method</label>
// // // // // //             <select
// // // // // //               value={convertedFields.method}
// // // // // //               onChange={(e) => handleConvertedFieldChange("method", e.target.value)}
// // // // // //               className="border p-2 rounded w-full"
// // // // // //               style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
// // // // // //               required
// // // // // //             >
// // // // // //               <option value="">Select Payment Method</option>
// // // // // //               {paymentMethods.map((method) => (
// // // // // //                 <option key={method} value={method}>
// // // // // //                   {method}
// // // // // //                 </option>
// // // // // //               ))}
// // // // // //             </select>
// // // // // //           </div>
// // // // // //           <div style={{ display: "flex", flexDirection: "column" }}>
// // // // // //             <label className="block font-bold">Collected By</label>
// // // // // //             <input
// // // // // //               type="text"
// // // // // //               value={convertedFields.collectedBy}
// // // // // //               onChange={(e) => handleConvertedFieldChange("collectedBy", e.target.value)}
// // // // // //               className="border p-2 rounded w-full"
// // // // // //               style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
// // // // // //               required
// // // // // //             />
// // // // // //           </div>
// // // // // //           <div style={{ display: "flex", flexDirection: "column" }}>
// // // // // //             <label className="block font-bold">Transaction ID</label>
// // // // // //             <input
// // // // // //               type="text"
// // // // // //               value={convertedFields.transactionId}
// // // // // //               onChange={(e) => handleConvertedFieldChange("transactionId", e.target.value)}
// // // // // //               className="border p-2 rounded w-full"
// // // // // //               style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
// // // // // //               required
// // // // // //             />
// // // // // //           </div>
// // // // // //           <div style={{ display: "flex", flexDirection: "column" }}>
// // // // // //             <label className="block font-bold">Paid Towards</label>
// // // // // //             <input
// // // // // //               type="text"
// // // // // //               value={convertedFields.paidTowards}
// // // // // //               onChange={(e) => handleConvertedFieldChange("paidTowards", e.target.value)}
// // // // // //               className="border p-2 rounded w-full"
// // // // // //               style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
// // // // // //               placeholder="Deposit"
// // // // // //               required
// // // // // //             />
// // // // // //           </div>
// // // // // //         </div>
// // // // // //       )}

// // // // // //       {showConfirmation && (
// // // // // //         <div className="ConfirmOverlay">
// // // // // //           <div className="ConfirmOverlayContent">
// // // // // //             <h3>Confirm Status Change</h3>
// // // // // //             <p>
// // // // // //               This action will send the invoice receipt for the deposit taken for <strong> CA${convertedFields.depositamount}</strong> and also send the move details to the Crew-Prod with the invoice no <strong> {booking.LeadACVLRecordID}</strong>
// // // // // //             </p>
// // // // // //             <div className="ConfirmOverlayButtons">
// // // // // //               <button className="OverlayConfirmBtn" onClick={handleConfirm}>
// // // // // //                 Confirm
// // // // // //               </button>
// // // // // //               <button className="OverlayCloseBtn" onClick={handleCancelConfirmation}>
// // // // // //                 Cancel
// // // // // //               </button>
// // // // // //             </div>
// // // // // //           </div>
// // // // // //         </div>
// // // // // //       )}

// // // // // //       {!justSaved && !isCurrentStatusFinal && (
// // // // // //         <div className="flex gap-2" style={{ display: "flex", gap: "15px", alignItems: "center", justifyContent: "center" }}>
// // // // // //           <button
// // // // // //             onClick={handleSave}
// // // // // //             className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
// // // // // //             style={{ padding: "5px 10px", background: "gray", color: "#ffffff", borderRadius: "10px" }}
// // // // // //             disabled={isLoading}
// // // // // //           >
// // // // // //             Save
// // // // // //           </button>
// // // // // //           <button
// // // // // //             onClick={handleCancel}
// // // // // //             className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
// // // // // //             style={{ padding: "5px 10px", background: "gray", color: "#ffffff", borderRadius: "10px" }}
// // // // // //             disabled={isLoading}
// // // // // //           >
// // // // // //             Cancel
// // // // // //           </button>
// // // // // //         </div>
// // // // // //       )}
// // // // // //     </div>
// // // // // //   );
// // // // // // };

// // // // // // export default StatusChange;

// // // // // import React, { useState, useEffect } from "react";

// // // // // const StatusChange = ({ booking, updateBooking, accessToken }) => {
// // // // //   const [leadStatus, setLeadStatus] = useState("");
// // // // //   const [reason, setReason] = useState(booking.LeadStatusChangeReason || "");
// // // // //   const [followUpDate, setFollowUpDate] = useState(booking.FollowUpDate || "");
// // // // //   const [convertedFields, setConvertedFields] = useState({
// // // // //     dateOfPayment: booking.Converted_dateOfPayment || "",
// // // // //     depositamount: booking.Converted_depositamount || "",
// // // // //     method: booking.Converted_method || "",
// // // // //     collectedBy: booking.Converted_collectedBy || "",
// // // // //     transactionId: booking.Converted_transactionId || "",
// // // // //     paidTowards: booking.Converted_paidTowards || "",
// // // // //   });
// // // // //   const [error, setError] = useState("");
// // // // //   const [justSaved, setJustSaved] = useState(false);
// // // // //   const [leadStatusOptions, setLeadStatusOptions] = useState([]);
// // // // //   const [secondaryStatusOptions, setSecondaryStatusOptions] = useState({});
// // // // //   const [paymentMethods, setPaymentMethods] = useState([]);
// // // // //   const [showConfirmation, setShowConfirmation] = useState(false);
// // // // //   const [isLoading, setIsLoading] = useState(false);

// // // // //   const generateUniqueId = () => {
// // // // //     const timestamp = Date.now().toString(36);
// // // // //     const randomPart = Math.random().toString(36).substring(2, 10);
// // // // //     return `ACVL${timestamp}-${randomPart}`;
// // // // //   };

// // // // //   useEffect(() => {
// // // // //     const fetchStatusOptions = async () => {
// // // // //       try {
// // // // //         const response = await fetch("https://salesjet-10097049716.catalystappsail.com/emailtemp", {
// // // // //           method: "GET",
// // // // //           headers: {
// // // // //             "Content-Type": "application/json",
// // // // //             Authorization: `Bearer ${accessToken}`,
// // // // //           },
// // // // //         });

// // // // //         if (!response.ok) {
// // // // //           throw new Error("Failed to fetch status options");
// // // // //         }

// // // // //         const data = await response.json();
// // // // //         if (data.status === "success" && data.records) {
// // // // //           const statusSet = new Set();
// // // // //           const paymentMethodsSet = new Set();
// // // // //           data.records.forEach(record => {
// // // // //             if (record.LeadStatus) {
// // // // //               statusSet.add(record.LeadStatus);
// // // // //             }
// // // // //             if (record.paymentMethods) {
// // // // //               paymentMethodsSet.add(record.paymentMethods);
// // // // //             }
// // // // //           });
// // // // //           const groupedOptions = {};
// // // // //           statusSet.forEach(status => {
// // // // //             groupedOptions[status] = [];
// // // // //           });
// // // // //           data.records.forEach(record => {
// // // // //             const { secondaryStatusOptions: secondaryOption } = record;
// // // // //             if (secondaryOption) {
// // // // //               const firstWord = secondaryOption.split("-")[0].trim();
// // // // //               if (statusSet.has(firstWord)) {
// // // // //                 const statusKey = firstWord;
// // // // //                 if (!groupedOptions[statusKey].includes(secondaryOption)) {
// // // // //                   groupedOptions[statusKey].push(secondaryOption);
// // // // //                 }
// // // // //               }
// // // // //             }
// // // // //           });
// // // // //           const sortedStatuses = [...statusSet].sort();
// // // // //           const sortedPaymentMethods = [...paymentMethodsSet].sort();
// // // // //           setLeadStatusOptions(sortedStatuses);
// // // // //           setSecondaryStatusOptions(groupedOptions);
// // // // //           setPaymentMethods(sortedPaymentMethods);
// // // // //         } else {
// // // // //           setError("No status options found in response");
// // // // //         }
// // // // //       } catch (error) {
// // // // //         console.error("Error fetching status options", error);
// // // // //         setError("Failed to load status options. Please try again.");
// // // // //       }
// // // // //     };

// // // // //     fetchStatusOptions();
// // // // //   }, [accessToken]);

// // // // //   useEffect(() => {
// // // // //     if (justSaved) {
// // // // //       return;
// // // // //     }
// // // // //     setLeadStatus("");
// // // // //     setReason(booking.LeadStatusChangeReason || "");
// // // // //     setFollowUpDate(booking.FollowUpDate || "");
// // // // //     setConvertedFields({
// // // // //       dateOfPayment: booking.Converted_dateOfPayment || "",
// // // // //       depositamount: booking.Converted_depositamount || "",
// // // // //       method: booking.Converted_method || "",
// // // // //       collectedBy: booking.Converted_collectedBy || "",
// // // // //       transactionId: booking.Converted_transactionId || "",
// // // // //       paidTowards: booking.Converted_paidTowards || "",
// // // // //     });
// // // // //     setError("");
// // // // //   }, [
// // // // //     booking.LeadStatusChangeReason,
// // // // //     booking.FollowUpDate,
// // // // //     booking.Converted_dateOfPayment,
// // // // //     booking.Converted_depositamount,
// // // // //     booking.Converted_method,
// // // // //     booking.Converted_collectedBy,
// // // // //     booking.Converted_transactionId,
// // // // //     booking.Converted_paidTowards,
// // // // //     booking.Lead_Status,
// // // // //     justSaved,
// // // // //   ]);

// // // // //   const handleStatusChange = (e) => {
// // // // //     const newStatus = e.target.value;
// // // // //     setLeadStatus(newStatus);

// // // // //     if (!secondaryStatusOptions[newStatus]) {
// // // // //       setReason("");
// // // // //     }

// // // // //     if (newStatus !== "Open") {
// // // // //       setFollowUpDate("");
// // // // //     }

// // // // //     if (newStatus !== "Converted") {
// // // // //       setConvertedFields({
// // // // //         dateOfPayment: "",
// // // // //         depositamount: "",
// // // // //         method: "",
// // // // //         collectedBy: "",
// // // // //         transactionId: "",
// // // // //         paidTowards: "",
// // // // //       });
// // // // //     }
// // // // //   };

// // // // //   const handleReasonChange = (e) => {
// // // // //     setReason(e.target.value);
// // // // //   };

// // // // //   const handleFollowUpDateChange = (e) => {
// // // // //     setFollowUpDate(e.target.value);
// // // // //   };

// // // // //   const handleConvertedFieldChange = (field, value) => {
// // // // //     setConvertedFields((prev) => ({ ...prev, [field]: value }));
// // // // //   };

// // // // //   const validateFields = () => {
// // // // //     if (!leadStatus) {
// // // // //       return "Lead Status is required";
// // // // //     }
// // // // //     const hasReasonOptions = secondaryStatusOptions[leadStatus] && secondaryStatusOptions[leadStatus].length > 0;
// // // // //     if (hasReasonOptions && !reason) {
// // // // //       return "Reason is required";
// // // // //     }
// // // // //     if (leadStatus === "Open" && !followUpDate) {
// // // // //       return "Follow Up Date is required";
// // // // //     }
// // // // //     if (leadStatus === "Converted") {
// // // // //       for (const [key, value] of Object.entries(convertedFields)) {
// // // // //         if (!value) {
// // // // //           return `${key.replace(/([A-Z])/g, " $1").trim()} is required`;
// // // // //         }
// // // // //       }
// // // // //     }
// // // // //     return "";
// // // // //   };

// // // // //   const handleSave = async () => {
// // // // //     const validationError = validateFields();
// // // // //     if (validationError) {
// // // // //       setError(validationError);
// // // // //       return;
// // // // //     }

// // // // //     if (leadStatus === "Converted") {
// // // // //       setShowConfirmation(true);
// // // // //       return;
// // // // //     }

// // // // //     await performSave();
// // // // //   };

// // // // //   const performSave = async () => {
// // // // //     setError("");
// // // // //     setIsLoading(true);

// // // // //     if (!booking?.ROWID || !booking?.LeadACVLRecordID) {
// // // // //       setError("Missing required booking data (ROWID or LeadACVLRecordID).");
// // // // //       setIsLoading(false);
// // // // //       return;
// // // // //     }

// // // // //     const updatedData = [
// // // // //       {
// // // // //         ROWID: booking.ROWID,
// // // // //         Lead_Status: leadStatus,
// // // // //         LeadStatusChangeReason: reason || "",
// // // // //         FollowUpDate: leadStatus === "Open" ? followUpDate : "",
// // // // //         ...(leadStatus === "Converted" && {
// // // // //           Converted_dateOfPayment: convertedFields.dateOfPayment || "",
// // // // //           Converted_depositamount: convertedFields.depositamount || "",
// // // // //           Converted_method: convertedFields.method || "",
// // // // //           Converted_collectedBy: convertedFields.collectedBy || "",
// // // // //           Converted_transactionId: convertedFields.transactionId || "",
// // // // //           Converted_paidTowards: convertedFields.paidTowards || "",
// // // // //         }),
// // // // //       },
// // // // //     ];

// // // // //     try {
// // // // //       console.log("Updating leads data:", updatedData);
// // // // //       const leadsResponse = await fetch("https://salesjet-10097049716.catalystappsail.com/leadsdata", {
// // // // //         method: "PUT",
// // // // //         headers: {
// // // // //           "Content-Type": "application/json",
// // // // //           Authorization: `Bearer ${accessToken}`,
// // // // //         },
// // // // //         body: JSON.stringify(updatedData),
// // // // //       });

// // // // //       if (!leadsResponse.ok) {
// // // // //         const errorText = await leadsResponse.text();
// // // // //         throw new Error(`Leads data update failed: ${errorText} (Status: ${leadsResponse.status})`);
// // // // //       }
// // // // //       console.log("Leads data updated successfully");

// // // // //       // Update booking state immediately for all statuses
// // // // //       updateBooking("Lead_Status", leadStatus, {
// // // // //         LeadStatusChangeReason: reason || "",
// // // // //         FollowUpDate: leadStatus === "Open" ? followUpDate : "",
// // // // //         ...(leadStatus === "Converted" && {
// // // // //           Converted_dateOfPayment: convertedFields.dateOfPayment || "",
// // // // //           Converted_depositamount: convertedFields.depositamount || "",
// // // // //           Converted_method: convertedFields.method || "",
// // // // //           Converted_collectedBy: convertedFields.collectedBy || "",
// // // // //           Converted_transactionId: convertedFields.transactionId || "",
// // // // //           Converted_paidTowards: convertedFields.paidTowards || "",
// // // // //         }),
// // // // //       });

// // // // //       if (leadStatus === "Converted") {
// // // // //         const recordId = generateUniqueId();
// // // // //         const Invoicelink = `https://salesjet.allcanadavanlines.com/app/index.html#/estimate/${booking.LeadACVLRecordID}`;

// // // // //         const bookingData = [
// // // // //           {
// // // // //             Lead_ID: booking.LeadProviderLeadId || "",
// // // // //             Invoicelink,
// // // // //             Sales_Agent: booking.Sales_Agent || "Unknown",
// // // // //             Move_Size: booking.Move_Size || "",
// // // // //             MoveDate: booking.Move_Date || "",   
// // // // //             Delivery_Date: booking.DeliveryDate || "",
// // // // //             FlexibleDelivery_Date: booking.FlexibleDeliveryDate || "",
// // // // //             INVOICE: booking.LeadACVLRecordID,
// // // // //             Move_From: booking.OriginCity || "",
// // // // //             Move_To: booking.DestinationCity || "",
// // // // //             Estimate_No: booking.LeadACVLRecordID,
// // // // //             Banner: booking.Banner || "",
// // // // //             Booked_Date: new Date().toISOString(),
// // // // //             Status: "Received From SalesJet",
// // // // //             From_Address: booking.FromAddress || "",
// // // // //             To_Address: booking.ToAddress || "",
// // // // //             Move_Type: booking.Move_Type || "",
// // // // //             Customer_Name: booking.Customer_Name || "",
// // // // //             Email_Address: booking.Email || "",
// // // // //             Phone_Number: booking.Phone_Number || "",
// // // // //             Estimate_Amount: booking.Estimate_Amount || 0,
// // // // //             Record_ID: recordId, 
// // // // //             Long_Walk: booking.LongWalk || "",
// // // // //             NoOfStaircasesAtOrigin: booking.NoOfStaircasesAtOrigin || 0,
// // // // //             NoOfStaircasesAtDestination: booking.NoOfStaircasesAtDestination || 0,
// // // // //             Elevator: booking.ServiceElevatorAvailability || 0,
// // // // //             OriginPropertyType: booking.OriginPropertyType || "",
// // // // //             DestinationPropertyType: booking.DestinationPropertyType || "",
// // // // //             HeavyEquipments: booking.HeavyEquipments || "",
// // // // //             Packing: booking.NeedPackingServices || "",
// // // // //             Packing_Material: booking.PackingSupplies || "",
// // // // //             Parking_Available: booking.ParkingAvailable || "",
// // // // //             DismantlingOfFurnitures: booking.DismantlingOfFurnitures || "",
// // // // //             ToolsRequired: booking.ToolsRequired || "",
// // // // //             Inventory_List: booking.Inventory_List || "",
// // // // //           },
// // // // //         ];

// // // // //         const paymentData = [
// // // // //           {
// // // //             // amount: parseFloat(convertedFields.depositamount) || 0,
// // // //             // collectedBy: convertedFields.collectedBy || "",
// // // //             // dateofpayment: convertedFields.dateOfPayment || "",
// // // //             // method: convertedFields.method || "",
// // // //             // paidTowards: convertedFields.paidTowards || "",
// // // //             // transactionId: convertedFields.transactionId || "",
// // // //             // Record_ID: recordId,
// // // //             // INVOICE: booking.LeadACVLRecordID,
// // // // //           },
// // // // //         ];

// // // // //         const depositAmount = parseFloat(convertedFields.depositamount) || 0;
// // // // //         if (depositAmount <= 0) {
// // // // //           throw new Error("Deposit amount must be greater than zero.");
// // // // //         }

// // // // //         const confirmBookingPayload = {
// // // // //           customerEmail: booking.Email,
// // // // //           DisplayName: booking.Customer_Name,
// // // // //           invoiceData: {
// // // // //             BillEmail: {
// // // // //               Address: booking.Email,
// // // // //             },
// // // // //             DocNumber: booking.LeadACVLRecordID,
// // // // //             TxnDate: new Date().toISOString().split("T")[0],
// // // // //             DueDate: booking.Move_Date,
// // // // //             CustomField: [
// // // // //               {
// // // // //                 DefinitionId: '1',
// // // // //                 Name: 'Sales Agent',
// // // // //                 Type: 'StringType',
// // // // //                 StringValue: 'Paul1',
// // // // //               },
// // // // //             ],
// // // // //             BillAddr: {
// // // // //               Line1: booking.FromAddress,
// // // // //               Country: "CA",
// // // // //             },
// // // // //             ShipAddr: {
// // // // //               Line1: booking.ToAddress,
// // // // //               Country: "CA",
// // // // //             },
// // // // //             CustomerMemo: {
// // // // //               value: "Receipt deposit for your upcoming move. This will be applied toward your final invoice.",
// // // // //             },
// // // // //             GlobalTaxCalculation: "NotApplicable",
// // // // //             Line: [
// // // // //               {
// // // // //                 Id: "1",
// // // // //                 LineNum: 1,
// // // // //                 Description: "Deposit Towards Move Booked",
// // // // //                 Amount: depositAmount,
// // // // //                 DetailType: "SalesItemLineDetail",
// // // // //                 SalesItemLineDetail: {
// // // // //                   ItemRef: { value: "1", name: "Services" },
// // // // //                   UnitPrice: depositAmount,
// // // // //                   Qty: 1,
// // // // //                   ItemAccountRef: { value: "52", name: "Services" },
// // // // //                 },
// // // // //               },
// // // // //             ],
// // // // //             Deposit: depositAmount,
// // // // //             DepositToAccountRef: {
// // // // //               value: "5",
// // // // //               name: "Undeposited Funds",
// // // // //             },
// // // // //           },
// // // // //         };

// // // // //         const updateStatusPayload = [
// // // // //           {
// // // // //             ROWID: booking.ROWID,
// // // // //             Status: "Booked",
// // // // //           },
// // // // //         ];

// // // // //         console.log("Sending booking data:", bookingData);
// // // // //         console.log("Sending payment data:", paymentData);
// // // // //         console.log("Sending QuickBooks payload:", confirmBookingPayload);
// // // // //         console.log("Sending status update:", updateStatusPayload);

// // // // //         const [bookingResponse, paymentResponse, confirmBookingResponse, statusUpdateResponse] = await Promise.all([
// // // // //           fetch("https://salesjet-10097049716.catalystappsail.com/bookingdata", {
// // // // //             method: "POST",
// // // // //             headers: {
// // // // //               "Content-Type": "application/json",
// // // // //             },
// // // // //             body: JSON.stringify(bookingData),
// // // // //           }).catch((err) => {
// // // // //             throw new Error(`Booking data API failed: ${err.message}`);
// // // // //           }),
// // // // //           fetch("https://salesjet-10097049716.catalystappsail.com/Payment", {
// // // // //             method: "POST",
// // // // //             headers: {
// // // // //               "Content-Type": "application/json",
// // // // //             },
// // // // //             body: JSON.stringify(paymentData),
// // // // //           }).catch((err) => {
// // // // //             throw new Error(`Payment data API failed: ${err.message}`);
// // // // //           }),
// // // // //           fetch("https://salesjet-841904208.catalystserverless.com/server/qb_post/handle-invoice", {
// // // // //             method: "POST",
// // // // //             headers: {
// // // // //               "Content-Type": "application/json",
// // // // //             },
// // // // //             body: JSON.stringify(confirmBookingPayload),
// // // // //           }).catch((err) => {
// // // // //             throw new Error(`QuickBooks invoice API failed: ${err.message}`);
// // // // //           }),
// // // // //           fetch("https://salesjet-10097049716.catalystappsail.com/leadsdata", {
// // // // //             method: "PUT",
// // // // //             headers: {
// // // // //               "Content-Type": "application/json",
// // // // //               Authorization: `Bearer ${accessToken}`,
// // // // //             },
// // // // //             body: JSON.stringify(updateStatusPayload),
// // // // //           }).catch((err) => {
// // // // //             throw new Error(`Status update API failed: ${err.message}`);
// // // // //           }),
// // // // //         ]);

// // // // //         if (!bookingResponse.ok) {
// // // // //           const errorText = await bookingResponse.text();
// // // // //           throw new Error(`Booking data save failed: ${errorText} (Status: ${bookingResponse.status})`);
// // // // //         }
// // // // //         console.log("Booking data saved successfully");

// // // // //         if (!paymentResponse.ok) {
// // // // //           const errorText = await paymentResponse.text();
// // // // //           throw new Error(`Payment data save failed: ${errorText} (Status: ${paymentResponse.status})`);
// // // // //         }
// // // // //         console.log("Payment data saved successfully");

// // // // //         if (!confirmBookingResponse.ok) {
// // // // //           let errorData = {};
// // // // //           try {
// // // // //             errorData = await confirmBookingResponse.json();
// // // // //           } catch (jsonError) {
// // // // //             console.error("Failed to parse QuickBooks error:", jsonError);
// // // // //           }
// // // // //           throw new Error(
// // // // //             `QuickBooks invoice failed: ${errorData.Fault?.Error?.[0]?.Message || "Unknown error"} (${
// // // // //               errorData.Fault?.Error?.[0]?.Detail || "No details"
// // // // //             }) (Status: ${confirmBookingResponse.status})`
// // // // //           );
// // // // //         }
// // // // //         console.log("QuickBooks invoice created successfully");

// // // // //         if (!statusUpdateResponse.ok) {
// // // // //           const errorText = await statusUpdateResponse.text();
// // // // //           throw new Error(`Status update failed: ${errorText} (Status: ${statusUpdateResponse.status})`);
// // // // //         }
// // // // //         console.log("Status updated successfully");

// // // // //         updateBooking("Status", "Book Executed");
// // // // //       }

// // // // //       // Update local state after successful save
// // // // //       setJustSaved(true);
// // // // //       setError("");
// // // // //       console.log("Save completed successfully");
// // // // //     } catch (error) {
// // // // //       console.error("Error in performSave:", error);
// // // // //       setError(`Failed to save changes: ${error.message}`);
// // // // //       setJustSaved(false);
// // // // //     } finally {
// // // // //       setIsLoading(false);
// // // // //       setShowConfirmation(false);
// // // // //     }
// // // // //   };

// // // // //   const handleConfirm = async () => {
// // // // //     await performSave();
// // // // //   };

// // // // //   const handleCancelConfirmation = () => {
// // // // //     setShowConfirmation(false);
// // // // //   };

// // // // //   const handleCancel = () => {
// // // // //     setLeadStatus("");
// // // // //     setReason(booking.LeadStatusChangeReason || "");
// // // // //     setFollowUpDate(booking.FollowUpDate || "");
// // // // //     setConvertedFields({
// // // // //       dateOfPayment: booking.Converted_dateOfPayment || "",
// // // // //       depositamount: booking.Converted_depositamount || "",
// // // // //       method: booking.Converted_method || "",
// // // // //       collectedBy: booking.Converted_collectedBy || "",
// // // // //       transactionId: booking.Converted_transactionId || "",
// // // // //       paidTowards: booking.Converted_paidTowards || "",
// // // // //     });
// // // // //     setError("");
// // // // //     setJustSaved(false);
// // // // //   };

// // // // //   const displayedCurrentStatus = justSaved ? leadStatus : booking.Lead_Status || "None";
// // // // //   const isStatusFinal = ["Converted"].includes(leadStatus);
// // // // //   const isCurrentStatusFinal = justSaved
// // // // //     ? ["Converted"].includes(leadStatus)
// // // // //     : ["Converted"].includes(booking.Lead_Status);
// // // // //   const reasonOptionsKey = leadStatus && leadStatus !== (booking.Lead_Status || "None")
// // // // //     ? leadStatus
// // // // //     : booking.Lead_Status || "None";

// // // // //   return (
// // // // //     <div className="status-change-section p-4" style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "5px" }}>
// // // // //       {error && <div className="text-red-500 mb-2">{error}</div>}
// // // // //       {isLoading && (
// // // // //         <div className="LoadingOverlay">
// // // // //           <div className="LoadingOverlayContent">
// // // // //             <div className="Spinner"></div>
// // // // //             <p>Processing...</p>
// // // // //           </div>
// // // // //         </div>
// // // // //       )}

// // // // //       <div
// // // // //         className="mb-4"
// // // // //         style={{
// // // // //           padding: "10px",
// // // // //           display: "flex",
// // // // //           justifyContent: isCurrentStatusFinal ? "flex-start" : "space-between",
// // // // //           alignItems: "center",
// // // // //         }}
// // // // //       >
// // // // //         <div className={isCurrentStatusFinal ? "w-full" : "w-1/3"}>
// // // // //           <strong>Current Status:</strong> {displayedCurrentStatus}
// // // // //         </div>
// // // // //         {!isCurrentStatusFinal && (
// // // // //           <>
// // // // //             <div className="w-1/6 text-center" style={{ fontSize: "30px" }}>
// // // // //               <span className="text-2xl">→</span>
// // // // //             </div>
// // // // //             <div className="w-1/2">
// // // // //               {!isStatusFinal && (
// // // // //                 <div style={{ display: "flex" }}>
// // // // //                   <label htmlFor="lead-status" className="block font-bold">
// // // // //                     New Lead Status:
// // // // //                   </label>
// // // // //                   <select
// // // // //                     id="lead-status"
// // // // //                     value={leadStatus}
// // // // //                     onChange={handleStatusChange}
// // // // //                     className="border p-2 rounded w-full"
// // // // //                     required
// // // // //                   >
// // // // //                     <option value="">Select Status</option>
// // // // //                     {leadStatusOptions.map((status) => (
// // // // //                       <option key={status} value={status}>
// // // // //                         {status}
// // // // //                       </option>
// // // // //                     ))}
// // // // //                   </select>
// // // // //                 </div>
// // // // //               )}
// // // // //               {isStatusFinal && (
// // // // //                 <div>
// // // // //                   <label htmlFor="lead-status" className="block font-bold">
// // // // //                     New Status:
// // // // //                   </label>
// // // // //                   {leadStatus}
// // // // //                 </div>
// // // // //               )}
// // // // //             </div>
// // // // //           </>
// // // // //         )}
// // // // //       </div>

// // // // //       <hr className="border-gray-300 mb-4" />

// // // // //       <div
// // // // //         className="grid grid-cols-2 gap-4 mb-4"
// // // // //         style={{ padding: "10px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}
// // // // //       >
// // // // //         {secondaryStatusOptions[reasonOptionsKey] && secondaryStatusOptions[reasonOptionsKey].length > 0 && (
// // // // //           <div style={{ display: "flex", flexDirection: "column" }}>
// // // // //             <label htmlFor="reason" className="block font-bold">
// // // // //               Reason
// // // // //             </label>
// // // // //             <select
// // // // //               id="reason"
// // // // //               value={reason}
// // // // //               onChange={handleReasonChange}
// // // // //               className="border p-2 rounded w-full"
// // // // //               style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
// // // // //               required
// // // // //             >
// // // // //               <option value="">Select Reason</option>
// // // // //               {secondaryStatusOptions[reasonOptionsKey].map((opt) => (
// // // // //                 <option key={opt} value={opt}>
// // // // //                   {opt}
// // // // //                 </option>
// // // // //               ))}
// // // // //             </select>
// // // // //           </div>
// // // // //         )}
// // // // //         {(leadStatus === "Open" || (displayedCurrentStatus === "Open" && leadStatus === "")) && (
// // // // //           <div style={{ display: "flex", flexDirection: "column" }}>
// // // // //             <label htmlFor="follow-up-date" className="block font-bold">
// // // // //               Follow Up Date
// // // // //             </label>
// // // // //             <input
// // // // //               id="follow-up-date"
// // // // //               type="date"
// // // // //               value={followUpDate}
// // // // //               onChange={leadStatus === "Open" ? handleFollowUpDateChange : undefined}
// // // // //               className="border p-2 rounded w-full"
// // // // //               style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
// // // // //               required={leadStatus === "Open"}
// // // // //               readOnly={leadStatus !== "Open"}
// // // // //             />
// // // // //           </div>
// // // // //         )}
// // // // //       </div>

// // // // //       {(leadStatus === "Converted" || booking.Lead_Status === "Converted") && (
// // // // //         <div
// // // // //           className="converted-fields grid grid-cols-2 gap-4 mb-4"
// // // // //           style={{ padding: "10px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}
// // // // //         >
// // // // //           <div style={{ display: "flex", flexDirection: "column" }}>
// // // // //             <label className="block font-bold">Date of Payment</label>
// // // // //             <input
// // // // //               type="date"
// // // // //               value={convertedFields.dateOfPayment}
// // // // //               onChange={(e) => handleConvertedFieldChange("dateOfPayment", e.target.value)}
// // // // //               className="border p-2 rounded w-full"
// // // // //               style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
// // // // //               required
// // // // //             />
// // // // //           </div>
// // // // //           <div style={{ display: "flex", flexDirection: "column" }}>
// // // // //             <label className="block font-bold">Deposit Amount</label>
// // // // //             <input
// // // // //               type="number"
// // // // //               value={convertedFields.depositamount}
// // // // //               onChange={(e) => handleConvertedFieldChange("depositamount", e.target.value)}
// // // // //               className="border p-2 rounded w-full"
// // // // //               style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
// // // // //               required
// // // // //             />
// // // // //           </div>
// // // // //           <div style={{ display: "flex", flexDirection: "column" }}>
// // // // //             <label className="block font-bold">Method</label>
// // // // //             <select
// // // // //               value={convertedFields.method}
// // // // //               onChange={(e) => handleConvertedFieldChange("method", e.target.value)}
// // // // //               className="border p-2 rounded w-full"
// // // // //               style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
// // // // //               required
// // // // //             >
// // // // //               <option value="">Select Payment Method</option>
// // // // //               {paymentMethods.map((method) => (
// // // // //                 <option key={method} value={method}>
// // // // //                   {method}
// // // // //                 </option>
// // // // //               ))}
// // // // //             </select>
// // // // //           </div>
// // // // //           <div style={{ display: "flex", flexDirection: "column" }}>
// // // // //             <label className="block font-bold">Collected By</label>
// // // // //             <input
// // // // //               type="text"
// // // // //               value={convertedFields.collectedBy}
// // // // //               onChange={(e) => handleConvertedFieldChange("collectedBy", e.target.value)}
// // // // //               className="border p-2 rounded w-full"
// // // // //               style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
// // // // //               required
// // // // //             />
// // // // //           </div>
// // // // //           <div style={{ display: "flex", flexDirection: "column" }}>
// // // // //             <label className="block font-bold">Transaction ID</label>
// // // // //             <input
// // // // //               type="text"
// // // // //               value={convertedFields.transactionId}
// // // // //               onChange={(e) => handleConvertedFieldChange("transactionId", e.target.value)}
// // // // //               className="border p-2 rounded w-full"
// // // // //               style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
// // // // //               required
// // // // //             />
// // // // //           </div>
// // // // //           <div style={{ display: "flex", flexDirection: "column" }}>
// // // // //             <label className="block font-bold">Paid Towards</label>
// // // // //             <input
// // // // //               type="text"
// // // // //               value={convertedFields.paidTowards}
// // // // //               onChange={(e) => handleConvertedFieldChange("paidTowards", e.target.value)}
// // // // //               className="border p-2 rounded w-full"
// // // // //               style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
// // // // //               placeholder="Deposit"
// // // // //               required
// // // // //             />
// // // // //           </div>
// // // // //         </div>
// // // // //       )}

// // // // //       {showConfirmation && (
// // // // //         <div className="ConfirmOverlay">
// // // // //           <div className="ConfirmOverlayContent">
// // // // //             <h3>Confirm Status Change</h3>
// // // // //             <p>
// // // // //               This action will send the invoice receipt for the deposit taken for <strong> CA${convertedFields.depositamount}</strong> and also send the move details to the Crew-Prod with the invoice no <strong> {booking.LeadACVLRecordID}</strong>
// // // // //             </p>
// // // // //             <div className="ConfirmOverlayButtons">
// // // // //               <button className="OverlayConfirmBtn" onClick={handleConfirm}>
// // // // //                 Confirm
// // // // //               </button>
// // // // //               <button className="OverlayCloseBtn" onClick={handleCancelConfirmation}>
// // // // //                 Cancel
// // // // //               </button>
// // // // //             </div>
// // // // //           </div>
// // // // //         </div>
// // // // //       )}

// // // // //       {!justSaved && !isCurrentStatusFinal && (
// // // // //         <div className="flex gap-2" style={{ display: "flex", gap: "15px", alignItems: "center", justifyContent: "center" }}>
// // // // //           <button
// // // // //             onClick={handleSave}
// // // // //             className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
// // // // //             style={{ padding: "5px 10px", background: "gray", color: "#ffffff", borderRadius: "10px" }}
// // // // //             disabled={isLoading}
// // // // //           >
// // // // //             Save
// // // // //           </button>
// // // // //           <button
// // // // //             onClick={handleCancel}
// // // // //             className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
// // // // //             style={{ padding: "5px 10px", background: "gray", color: "#ffffff", borderRadius: "10px" }}
// // // // //             disabled={isLoading}
// // // // //           >
// // // // //             Cancel
// // // // //           </button>
// // // // //         </div>
// // // // //       )}
// // // // //     </div>
// // // // //   );
// // // // // };

// // // // // export default StatusChange;

// // // // import React, { useState, useEffect } from "react";

// // // // const StatusChange = ({ booking, updateBooking, accessToken }) => {
// // // //   const [leadStatus, setLeadStatus] = useState("");
// // // //   const [reason, setReason] = useState(booking.LeadStatusChangeReason || "");
// // // //   const [followUpDate, setFollowUpDate] = useState(booking.FollowUpDate || "");
// // // //   const [convertedFields, setConvertedFields] = useState({
// // // //     dateOfPayment: booking.Converted_dateOfPayment || "",
// // // //     depositamount: booking.Converted_depositamount || "",
// // // //     method: booking.Converted_method || "",
// // // //     collectedBy: booking.Converted_collectedBy || "",
// // // //     transactionId: booking.Converted_transactionId || "",
// // // //     paidTowards: booking.Converted_paidTowards || "",
// // // //   });
// // // //   const [error, setError] = useState("");
// // // //   const [justSaved, setJustSaved] = useState(false);
// // // //   const [leadStatusOptions, setLeadStatusOptions] = useState([]);
// // // //   const [secondaryStatusOptions, setSecondaryStatusOptions] = useState({});
// // // //   const [paymentMethods, setPaymentMethods] = useState([]);
// // // //   const [showConfirmation, setShowConfirmation] = useState(false);
// // // //   const [isLoading, setIsLoading] = useState(false);
// // // //   const [showMissingFields, setShowMissingFields] = useState(false);
// // // //   const [missingFields, setMissingFields] = useState([]);

// // // //   const generateUniqueId = () => {
// // // //     const timestamp = Date.now().toString(36);
// // // //     const randomPart = Math.random().toString(36).substring(2, 10);
// // // //     return `ACVL${timestamp}-${randomPart}`;
// // // //   };

// // // //   useEffect(() => {
// // // //     const fetchStatusOptions = async () => {
// // // //       try {
// // // //         const response = await fetch("https://salesjet-10097049716.catalystappsail.com/emailtemp", {
// // // //           method: "GET",
// // // //           headers: {
// // // //             "Content-Type": "application/json",
// // // //             Authorization: `Bearer ${accessToken}`,
// // // //           },
// // // //         });

// // // //         if (!response.ok) {
// // // //           throw new Error("Failed to fetch status options");
// // // //         }

// // // //         const data = await response.json();
// // // //         if (data.status === "success" && data.records) {
// // // //           const statusSet = new Set();
// // // //           const paymentMethodsSet = new Set();
// // // //           data.records.forEach(record => {
// // // //             if (record.LeadStatus) {
// // // //               statusSet.add(record.LeadStatus);
// // // //             }
// // // //             if (record.paymentMethods) {
// // // //               paymentMethodsSet.add(record.paymentMethods);
// // // //             }
// // // //           });
// // // //           const groupedOptions = {};
// // // //           statusSet.forEach(status => {
// // // //             groupedOptions[status] = [];
// // // //           });
// // // //           data.records.forEach(record => {
// // // //             const { secondaryStatusOptions: secondaryOption } = record;
// // // //             if (secondaryOption) {
// // // //               const firstWord = secondaryOption.split("-")[0].trim();
// // // //               if (statusSet.has(firstWord)) {
// // // //                 const statusKey = firstWord;
// // // //                 if (!groupedOptions[statusKey].includes(secondaryOption)) {
// // // //                   groupedOptions[statusKey].push(secondaryOption);
// // // //                 }
// // // //               }
// // // //             }
// // // //           });
// // // //           const sortedStatuses = [...statusSet].sort();
// // // //           const sortedPaymentMethods = [...paymentMethodsSet].sort();
// // // //           setLeadStatusOptions(sortedStatuses);
// // // //           setSecondaryStatusOptions(groupedOptions);
// // // //           setPaymentMethods(sortedPaymentMethods);
// // // //         } else {
// // // //           setError("No status options found in response");
// // // //         }
// // // //       } catch (error) {
// // // //         console.error("Error fetching status options", error);
// // // //         setError("Failed to load status options. Please try again.");
// // // //       }
// // // //     };

// // // //     fetchStatusOptions();
// // // //   }, [accessToken]);

// // // //   useEffect(() => {
// // // //     if (justSaved) {
// // // //       return;
// // // //     }
// // // //     setLeadStatus("");
// // // //     setReason(booking.LeadStatusChangeReason || "");
// // // //     setFollowUpDate(booking.FollowUpDate || "");
// // // //     setConvertedFields({
// // // //       dateOfPayment: booking.Converted_dateOfPayment || "",
// // // //       depositamount: booking.Converted_depositamount || "",
// // // //       method: booking.Converted_method || "",
// // // //       collectedBy: booking.Converted_collectedBy || "",
// // // //       transactionId: booking.Converted_transactionId || "",
// // // //       paidTowards: booking.Converted_paidTowards || "",
// // // //     });
// // // //     setError("");
// // // //   }, [
// // // //     booking.LeadStatusChangeReason,
// // // //     booking.FollowUpDate,
// // // //     booking.Converted_dateOfPayment,
// // // //     booking.Converted_depositamount,
// // // //     booking.Converted_method,
// // // //     booking.Converted_collectedBy,
// // // //     booking.Converted_transactionId,
// // // //     booking.Converted_paidTowards,
// // // //     booking.Lead_Status,
// // // //     justSaved,
// // // //   ]);

// // // //   const handleStatusChange = (e) => {
// // // //     const newStatus = e.target.value;
// // // //     setLeadStatus(newStatus);

// // // //     if (!secondaryStatusOptions[newStatus]) {
// // // //       setReason("");
// // // //     }

// // // //     if (newStatus !== "Open") {
// // // //       setFollowUpDate("");
// // // //     }

// // // //     if (newStatus !== "Converted") {
// // // //       setConvertedFields({
// // // //         dateOfPayment: "",
// // // //         depositamount: "",
// // // //         method: "",
// // // //         collectedBy: "",
// // // //         transactionId: "",
// // // //         paidTowards: "",
// // // //       });
// // // //     }
// // // //   };

// // // //   const handleReasonChange = (e) => {
// // // //     setReason(e.target.value);
// // // //   };

// // // //   const handleFollowUpDateChange = (e) => {
// // // //     setFollowUpDate(e.target.value);
// // // //   };

// // // //   const handleConvertedFieldChange = (field, value) => {
// // // //     setConvertedFields((prev) => ({ ...prev, [field]: value }));
// // // //   };

// // // //   const validateFields = () => {
// // // //     if (!leadStatus) {
// // // //       return "Lead Status is required";
// // // //     }
// // // //     const hasReasonOptions = secondaryStatusOptions[leadStatus] && secondaryStatusOptions[leadStatus].length > 0;
// // // //     if (hasReasonOptions && !reason) {
// // // //       return "Reason is required";
// // // //     }
// // // //     // if (leadStatus === "Open" && !followUpDate) {
// // // //     //   return "Follow Up Date is required";
// // // //     // }
// // // //     if (leadStatus === "Converted") {
// // // //       for (const [key, value] of Object.entries(convertedFields)) {
// // // //         if (!value) {
// // // //           return `${key.replace(/([A-Z])/g, " $1").trim()} is required`;
// // // //         }
// // // //       }
// // // //     }
// // // //     return "";
// // // //   };

// // // //   const validateBookingData = () => {
// // // //     const requiredFields = {
// // // //       LeadProviderLeadId: booking.LeadProviderLeadId,
// // // //       Sales_Agent: booking.Sales_Agent,
// // // //       Move_Size: booking.Move_Size,
// // // //       Move_Date: booking.Move_Date,
// // // //       DeliveryDate: booking.DeliveryDate,
// // // //       FlexibleDeliveryDate: booking.FlexibleDeliveryDate,
// // // //       OriginCity: booking.OriginCity,
// // // //       DestinationCity: booking.DestinationCity,
// // // //       LeadACVLRecordID: booking.LeadACVLRecordID,
// // // //       Banner: booking.Banner,
// // // //       FromAddress: booking.FromAddress,
// // // //       ToAddress: booking.ToAddress,
// // // //       Move_Type: booking.Move_Type,
// // // //       Customer_Name: booking.Customer_Name,
// // // //       Email: booking.Email,
// // // //       Phone_Number: booking.Phone_Number,
// // // //       LongWalkAtOrigin: booking.LongWalkAtOrigin || "",
// // // //       LongWalkAtDestination: booking.LongWalkAtDestination || "",
// // // //       NoOfStaircasesAtOrigin: booking.NoOfStaircasesAtOrigin,
// // // //       NoOfStaircasesAtDestination: booking.NoOfStaircasesAtDestination,
// // // //       ServiceElevatoratOrigin: booking.ServiceElevatoratOrigin || 0,
// // // //       ServiceElevatoratDestination: booking.ServiceElevatoratDestination || 0,
// // // //       OriginPropertyType: booking.OriginPropertyType,
// // // //       DestinationPropertyType: booking.DestinationPropertyType,
// // // //       HeavyEquipments: booking.HeavyEquipments,
// // // //       NeedPackingServices: booking.NeedPackingServices,
// // // //       PackingSupplies: booking.PackingSupplies,
// // // //       ParkingAvailableAtOrigin: booking.ParkingAvailableAtOrigin || "",
// // // //       ParkingAvailableAtDestination: booking.ParkingAvailableAtDestination || "",
// // // //       DismantlingOfFurnitures: booking.DismantlingOfFurnitures,
// // // //       ToolsRequired: booking.ToolsRequired,
// // // //       Inventory_List: booking.Inventory_List,
// // // //     };

// // // //     const missing = [];
// // // //     for (const [key, value] of Object.entries(requiredFields)) {
// // // //       if (value === undefined || value === null || value === "") {
// // // //         missing.push(key.replace(/([A-Z])/g, " $1").trim());
// // // //       }
// // // //     }
// // // //     return missing;
// // // //   };

// // // //   const handleSave = async () => {
// // // //     const validationError = validateFields();
// // // //     if (validationError) {
// // // //       setError(validationError);
// // // //       return;
// // // //     }

// // // //     if (leadStatus === "Converted") {
// // // //       const missing = validateBookingData();
// // // //       if (missing.length > 0) {
// // // //         setMissingFields(missing);
// // // //         setShowMissingFields(true);
// // // //         return;
// // // //       }
// // // //       setShowConfirmation(true);
// // // //       return;
// // // //     }

// // // //     await performSave();
// // // //   };

// // // //   const handleProceedToConfirmation = () => {
// // // //     setShowMissingFields(false);
// // // //     setShowConfirmation(true);
// // // //   };

// // // //   const handleCancelMissingFields = () => {
// // // //     setShowMissingFields(false);
// // // //     setError("");
// // // //   };

// // // //   const performSave = async () => {
// // // //     setError("");
// // // //     setIsLoading(true);

// // // //     if (!booking?.ROWID || !booking?.LeadACVLRecordID) {
// // // //       setError("Missing required booking data (ROWID or LeadACVLRecordID).");
// // // //       setIsLoading(false);
// // // //       return;
// // // //     }

// // // //     const updatedData = [
// // // //       {
// // // //         ROWID: booking.ROWID,
// // // //         Lead_Status: leadStatus,
// // // //         LeadStatusChangeReason: reason || "",
// // // //         FollowUpDate: leadStatus === "Open" ? followUpDate : "",
// // // //         ...(leadStatus === "Converted" && {
// // // //           Converted_dateOfPayment: convertedFields.dateOfPayment || "",
// // // //           Converted_depositamount: convertedFields.depositamount || "",
// // // //           Converted_method: convertedFields.method || "",
// // // //           Converted_collectedBy: convertedFields.collectedBy || "",
// // // //           Converted_transactionId: convertedFields.transactionId || "",
// // // //           Converted_paidTowards: convertedFields.paidTowards || "",
// // // //         }),
// // // //       },
// // // //     ];

// // // //     try {
// // // //       console.log("Updating leads data:", updatedData);
// // // //       const leadsResponse = await fetch("https://salesjet-10097049716.catalystappsail.com/leadsdata", {
// // // //         method: "PUT",
// // // //         headers: {
// // // //           "Content-Type": "application/json",
// // // //           Authorization: `Bearer ${accessToken}`,
// // // //         },
// // // //         body: JSON.stringify(updatedData),
// // // //       });

// // // //       if (!leadsResponse.ok) {
// // // //         const errorText = await leadsResponse.text();
// // // //         throw new Error(`Leads data update failed: ${errorText} (Status: ${leadsResponse.status})`);
// // // //       }
// // // //       console.log("Leads data updated successfully");

// // // //       updateBooking("Lead_Status", leadStatus, {
// // // //         LeadStatusChangeReason: reason || "",
// // // //         FollowUpDate: leadStatus === "Open" ? followUpDate : "",
// // // //         ...(leadStatus === "Converted" && {
// // // //           Converted_dateOfPayment: convertedFields.dateOfPayment || "",
// // // //           Converted_depositamount: convertedFields.depositamount || "",
// // // //           Converted_method: convertedFields.method || "",
// // // //           Converted_collectedBy: convertedFields.collectedBy || "",
// // // //           Converted_transactionId: convertedFields.transactionId || "",
// // // //           Converted_paidTowards: convertedFields.paidTowards || "",
// // // //         }),
// // // //       });

// // // //       if (leadStatus === "Converted") {

// // // //         const bookingData = [
// // // //           {
// // // //             LeadACVLRecordID: booking.LeadACVLRecordID,
// // // //           },
// // // //         ];

// // // //         const depositAmount = parseFloat(convertedFields.depositamount) || 0;
// // // //         if (depositAmount <= 0) {
// // // //           throw new Error("Deposit amount must be greater than zero.");
// // // //         }

// // // //           // const confirmBookingPayload = {
// // // //           //   customerEmail: booking.Email,
// // // //           //   DisplayName: booking.Customer_Name,
// // // //           //   invoiceData: {
// // // //           //     BillEmail: {
// // // //           //       Address: booking.Email,
// // // //           //     },
// // // //           //     DocNumber: booking.LeadACVLRecordID,
// // // //           //     TxnDate: new Date().toISOString().split("T")[0],
// // // //           //     DueDate: booking.Move_Date,
// // // //           //     CustomField: [
// // // //           //       {
// // // //           //         DefinitionId: '1',
// // // //           //         Name: 'Sales Agent',
// // // //           //         Type: 'StringType',
// // // //           //         StringValue: 'Paul1',
// // // //           //       },
// // // //           //     ],
// // // //           //     BillAddr: {
// // // //           //       Line1: booking.FromAddress,
// // // //           //       Country: "CA",
// // // //           //     },
// // // //           //     ShipAddr: {
// // // //           //       Line1: booking.ToAddress,
// // // //           //       Country: "CA",
// // // //           //     },
// // // //           //     CustomerMemo: {
// // // //           //       value: "Receipt deposit for your upcoming move. This will be applied toward your final invoice.",
// // // //           //     },
// // // //           //     GlobalTaxCalculation: "NotApplicable",
// // // //           //     Line: [
// // // //           //       {
// // // //           //         Id: "1",
// // // //           //         LineNum: 1,
// // // //           //         Description: "Deposit Towards Move Booked",
// // // //           //         Amount: depositAmount,
// // // //           //         DetailType: "SalesItemLineDetail",
// // // //           //         SalesItemLineDetail: {
// // // //           //           ItemRef: { value: "1", name: "Services" },
// // // //           //           UnitPrice: depositAmount,
// // // //           //           Qty: 1,
// // // //           //           ItemAccountRef: { value: "52", name: "Services" },
// // // //           //         },
// // // //           //       },
// // // //           //     ],
// // // //           //     Deposit: depositAmount,
// // // //           //     DepositToAccountRef: {
// // // //           //       value: "5",
// // // //           //       name: "Undeposited Funds",
// // // //           //     },
// // // //           //   },
// // // //           // };

// // // //     // commented due Qb discussed on 12/09/2025
// // // //         // const SendmailPayload = {
// // // //         //   toMail: booking.Email,
// // // //         //   subject: "Invoice Receipt - All Canada Van Lines",
// // // //         //   leadRecordId: booking.LeadACVLRecordID,
// // // //         //   content: "Please find the attached PDF for Lead " + booking.LeadACVLRecordID + "."
// // // //         // };

// // // //         const updateStatusPayload = [
// // // //           {
// // // //             ROWID: booking.ROWID,
// // // //             Status: "Booked",
// // // //           },
// // // //         ];

// // // //         // console.log("Sending booking data:", bookingData);
// // // //         // console.log("Sending payment data:", paymentData);
// // // //         // console.log("Sending QuickBooks payload:", confirmBookingPayload);
// // // //         // console.log("Sending status update:", updateStatusPayload);

// // // //         const [bookingResponse, statusUpdateResponse] = await Promise.all([
// // // //           fetch("https://salesjet-10097049716.catalystappsail.com/datatomovejet", {
// // // //             method: "POST",
// // // //             headers: {
// // // //               "Content-Type": "application/json",
// // // //               Authorization: `Bearer ${accessToken}`,
// // // //             },
// // // //             body: JSON.stringify(bookingData),
// // // //           }).catch((err) => {
// // // //             throw new Error(`Booking data API failed: ${err.message}`);
// // // //           }),
// // // //           // fetch("https://salesjet-10097049716.catalystappsail.com/estimatedata", {
// // // //           //   method: "POST",
// // // //           //   headers: {
// // // //           //     "Content-Type": "application/json",
// // // //           //     Authorization: `Bearer ${accessToken}`,
// // // //           //   },
// // // //           //   body: JSON.stringify(EstimateData),
// // // //           // }).catch((err) => {
// // // //           //   throw new Error(`Estimate data API failed: ${err.message}`);
// // // //           // }),
// // // //           // fetch("https://salesjet-10097049716.catalystappsail.com/Payment", {
// // // //           //   method: "POST",
// // // //           //   headers: {
// // // //           //     "Content-Type": "application/json",
// // // //           //     Authorization: `Bearer ${accessToken}`,
// // // //           //   },
// // // //           //   body: JSON.stringify(paymentData),
// // // //           // }).catch((err) => {
// // // //           //   throw new Error(`Payment data API failed: ${err.message}`);
// // // //           // }),
// // // //           // fetch("https://salesjet-841904208.catalystserverless.com/server/qb_post/handle-invoice", {
// // // //           //   method: "POST",
// // // //           //   headers: {
// // // //           //     "Content-Type": "application/json",
// // // //           //   },
// // // //           //   body: JSON.stringify(confirmBookingPayload),
// // // //           // }).catch((err) => {
// // // //           //   throw new Error(`QuickBooks invoice API failed: ${err.message}`);
// // // //           // }),
// // // //           // commented due Qb discussed on 12/09/2025
// // // //           // fetch("https://salesjet-841904208.catalystserverless.com/server/sales-jet-function/send-mail", {
// // // //           //   method: "POST",
// // // //           //   headers: {
// // // //           //     "Content-Type": "application/json",
// // // //           //   },
// // // //           //   body: JSON.stringify(SendmailPayload),
// // // //           // }).catch((err) => {
// // // //           //   throw new Error(`SendmailPayload API failed: ${err.message}`);
// // // //           // }),
// // // //           fetch("https://salesjet-10097049716.catalystappsail.com/leadsdata", {
// // // //             method: "PUT",
// // // //             headers: {
// // // //               "Content-Type": "application/json",
// // // //               Authorization: `Bearer ${accessToken}`,
// // // //             },
// // // //             body: JSON.stringify(),
// // // //           }).catch((err) => {
// // // //             throw new Error(`Status update API failed: ${err.message}`);
// // // //           }),updateStatusPayload
// // // //         ]);

// // // //         if (!bookingResponse.ok) {
// // // //           const errorText = await bookingResponse.text();
// // // //           throw new Error(`Booking data save failed: ${errorText} (Status: ${bookingResponse.status})`);
// // // //         }
// // // //         console.log("Booking data saved successfully");

// // // //         // if (!confirmBookingResponse.ok) {
// // // //         //   let errorData = {};
// // // //         //   try {
// // // //         //     errorData = await confirmBookingResponse.json();
// // // //         //   } catch (jsonError) {
// // // //         //     console.error("Failed to parse QuickBooks error:", jsonError);
// // // //         //   }
// // // //         //   throw new Error(
// // // //         //     `QuickBooks invoice failed: ${errorData.Fault?.Error?.[0]?.Message || "Unknown error"} (${
// // // //         //       errorData.Fault?.Error?.[0]?.Detail || "No details"
// // // //         //     }) (Status: ${confirmBookingResponse.status})`
// // // //         //   );
// // // //         // }
// // // //         // console.log("QuickBooks invoice created successfully");

// // // //         if (!statusUpdateResponse.ok) {
// // // //           const errorText = await statusUpdateResponse.text();
// // // //           throw new Error(`Status update failed: ${errorText} (Status: ${statusUpdateResponse.status})`);
// // // //         }
// // // //         console.log("Status updated successfully");

// // // //         updateBooking("Status", "Book Executed");
// // // //       }
// // // //       // Update local state after successful save
// // // //       setJustSaved(true);
// // // //       setError("");
// // // //       console.log("Save completed successfully");
// // // //     } catch (error) {
// // // //       console.error("Error in performSave:", error);
// // // //       setError(`Failed to save changes: ${error.message}`);
// // // //       setJustSaved(false);
// // // //     } finally {
// // // //       setIsLoading(false);
// // // //       setShowConfirmation(false);
// // // //     }
// // // //   };

// // // //   const handleConfirm = async () => {
// // // //     setShowConfirmation(false);
// // // //     await performSave();
// // // //   };

// // // //   const handleCancelConfirmation = () => {
// // // //     setShowConfirmation(false);
// // // //   };

// // // //   const handleCancel = () => {
// // // //     setLeadStatus("");
// // // //     setReason(booking.LeadStatusChangeReason || "");
// // // //     setFollowUpDate(booking.FollowUpDate || "");
// // // //     setConvertedFields({
// // // //       dateOfPayment: booking.Converted_dateOfPayment || "",
// // // //       depositamount: booking.Converted_depositamount || "",
// // // //       method: booking.Converted_method || "",
// // // //       collectedBy: booking.Converted_collectedBy || "",
// // // //       transactionId: booking.Converted_transactionId || "",
// // // //       paidTowards: booking.Converted_paidTowards || "",
// // // //     });
// // // //     setError("");
// // // //     setJustSaved(false);
// // // //   };

// // // //   const displayedCurrentStatus = justSaved ? leadStatus : booking.Lead_Status || "None";
// // // //   const isStatusFinal = ["Converted"].includes(leadStatus);
// // // //   const isCurrentStatusFinal = justSaved
// // // //     ? ["Converted"].includes(leadStatus)
// // // //     : ["Converted"].includes(booking.Lead_Status);
// // // //   const reasonOptionsKey = leadStatus && leadStatus !== (booking.Lead_Status || "None")
// // // //     ? leadStatus
// // // //     : booking.Lead_Status || "None";

// // // //   return (
// // // //     <div className="status-change-section p-4" style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "5px" }}>
// // // //       {error && <div className="text-red-500 mb-2">{error}</div>}
// // // //       {isLoading && (
// // // //         <div className="LoadingOverlay">
// // // //           <div className="LoadingOverlayContent">
// // // //             <div className="Spinner"></div>
// // // //             <p>Processing...</p>
// // // //           </div>
// // // //         </div>
// // // //       )}

// // // //       <div
// // // //         className="mb-4"
// // // //         style={{
// // // //           padding: "10px",
// // // //           display: "flex",
// // // //           justifyContent: isCurrentStatusFinal ? "flex-start" : "space-between",
// // // //           alignItems: "center",
// // // //         }}
// // // //       >
// // // //         <div className={isCurrentStatusFinal ? "w-full" : "w-1/3"}>
// // // //           <strong>Current Status:</strong> {displayedCurrentStatus}
// // // //         </div>
// // // //         {!isCurrentStatusFinal && (
// // // //           <>
// // // //             <div className="w-1/6 text-center" style={{ fontSize: "30px" }}>
// // // //               <span className="text-2xl">→</span>
// // // //             </div>
// // // //             <div className="w-1/2">
// // // //               {!isStatusFinal && (
// // // //                 <div style={{ display: "flex" }}>
// // // //                   <label htmlFor="lead-status" className="block font-bold">
// // // //                     New Lead Status:
// // // //                   </label>
// // // //                   <select
// // // //                     id="lead-status"
// // // //                     value={leadStatus}
// // // //                     onChange={handleStatusChange}
// // // //                     className="border p-2 rounded w-full"
// // // //                     required
// // // //                   >
// // // //                     <option value="">Select Status</option>
// // // //                     {leadStatusOptions.map((status) => (
// // // //                       <option key={status} value={status}>
// // // //                         {status}
// // // //                       </option>
// // // //                     ))}
// // // //                   </select>
// // // //                 </div>
// // // //               )}
// // // //               {isStatusFinal && (
// // // //                 <div>
// // // //                   <label htmlFor="lead-status" className="block font-bold">
// // // //                     New Status:
// // // //                   </label>
// // // //                   {leadStatus}
// // // //                 </div>
// // // //               )}
// // // //             </div>
// // // //           </>
// // // //         )}
// // // //       </div>

// // // //       <hr className="border-gray-300 mb-4" />

// // // //       <div
// // // //         className="grid grid-cols-2 gap-4 mb-4"
// // // //         style={{ padding: "10px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}
// // // //       >
// // // //         {secondaryStatusOptions[reasonOptionsKey] && secondaryStatusOptions[reasonOptionsKey].length > 0 && (
// // // //           <div style={{ display: "flex", flexDirection: "column" }}>
// // // //             <label htmlFor="reason" className="block font-bold">
// // // //               Reason
// // // //             </label>
// // // //             <select
// // // //               id="reason"
// // // //               value={reason}
// // // //               onChange={handleReasonChange}
// // // //               className="border p-2 rounded w-full"
// // // //               style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
// // // //               required
// // // //             >
// // // //               <option value="">Select Reason</option>
// // // //               {secondaryStatusOptions[reasonOptionsKey].map((opt) => (
// // // //                 <option key={opt} value={opt}>
// // // //                   {opt}
// // // //                 </option>
// // // //               ))}
// // // //             </select>
// // // //           </div>
// // // //         )}
// // // //       {/* command the follow up date in the status card on 29/09/2025 */}
// // // //         {/* {(leadStatus === "Open" || (displayedCurrentStatus === "Open" && leadStatus === "")) && (
// // // //           // <div style={{ display: "flex", flexDirection: "column" }}>
// // // //           //   <label htmlFor="follow-up-date" className="block font-bold">
// // // //           //     Follow Up Date
// // // //           //   </label>
// // // //           //   <input
// // // //           //     id="follow-up-date"
// // // //           //     type="datetime-local"
// // // //           //     value={followUpDate}
// // // //           //     onChange={leadStatus === "Open" ? handleFollowUpDateChange : undefined}
// // // //           //     className="border p-2 rounded w-full"
// // // //           //     min={new Date().toISOString().slice(0, 16)}
// // // //           //     style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
// // // //           //     required={leadStatus === "Open"}
// // // //           //     readOnly={leadStatus !== "Open"}
// // // //           //   />
// // // //           // </div>
// // // //         )} */}
// // // //       </div>

// // // //       {(leadStatus === "Converted" || booking.Lead_Status === "Converted") && (
// // // //         <div
// // // //           className="converted-fields grid grid-cols-2 gap-4 mb-4"
// // // //           style={{ padding: "10px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}
// // // //         >
// // // //           <div style={{ display: "flex", flexDirection: "column" }}>
// // // //             <label className="block font-bold">Date of Payment</label>
// // // //             <input
// // // //               type="date"
// // // //               value={convertedFields.dateOfPayment}
// // // //               onChange={(e) => handleConvertedFieldChange("dateOfPayment", e.target.value)}
// // // //               className="border p-2 rounded w-full"
// // // //               style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
// // // //               required
// // // //             />
// // // //           </div>
// // // //           <div style={{ display: "flex", flexDirection: "column" }}>
// // // //             <label className="block font-bold">Deposit Amount</label>
// // // //             <input
// // // //               type="number"
// // // //               value={convertedFields.depositamount}
// // // //               onChange={(e) => handleConvertedFieldChange("depositamount", e.target.value)}
// // // //               className="border p-2 rounded w-full"
// // // //               style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
// // // //               required
// // // //             />
// // // //           </div>
// // // //           <div style={{ display: "flex", flexDirection: "column" }}>
// // // //             <label className="block font-bold">Method</label>
// // // //             <select
// // // //               value={convertedFields.method}
// // // //               onChange={(e) => handleConvertedFieldChange("method", e.target.value)}
// // // //               className="border p-2 rounded w-full"
// // // //               style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
// // // //               required
// // // //             >
// // // //               <option value="">Select Payment Method</option>
// // // //               {paymentMethods.map((method) => (
// // // //                 <option key={method} value={method}>
// // // //                   {method}
// // // //                 </option>
// // // //               ))}
// // // //             </select>
// // // //           </div>
// // // //           <div style={{ display: "flex", flexDirection: "column" }}>
// // // //             <label className="block font-bold">Collected By</label>
// // // //             <input
// // // //               type="text"
// // // //               value={convertedFields.collectedBy}
// // // //               onChange={(e) => handleConvertedFieldChange("collectedBy", e.target.value)}
// // // //               className="border p-2 rounded w-full"
// // // //               style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
// // // //               required
// // // //             />
// // // //           </div>
// // // //           <div style={{ display: "flex", flexDirection: "column" }}>
// // // //             <label className="block font-bold">Transaction ID</label>
// // // //             <input
// // // //               type="text"
// // // //               value={convertedFields.transactionId}
// // // //               onChange={(e) => handleConvertedFieldChange("transactionId", e.target.value)}
// // // //               className="border p-2 rounded w-full"
// // // //               style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
// // // //               required
// // // //             />
// // // //           </div>
// // // //           <div style={{ display: "flex", flexDirection: "column" }}>
// // // //             <label className="block font-bold">Paid Towards</label>
// // // //             <input
// // // //               type="text"
// // // //               value={convertedFields.paidTowards}
// // // //               onChange={(e) => handleConvertedFieldChange("paidTowards", e.target.value)}
// // // //               className="border p-2 rounded w-full"
// // // //               style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
// // // //               placeholder="Deposit"
// // // //               required
// // // //             />
// // // //           </div>
// // // //         </div>
// // // //       )}

// // // //       {showMissingFields && (
// // // //         <div className="ConfirmOverlay">
// // // //           <div className="ConfirmOverlayContent" style={{textAlign: "left"}}>
// // // //             <h3>Missing Required Fields</h3>
// // // //             <p>The following fields are required to proceed with the booking:</p>
// // // //             <ul className="list-disc pl-5">
// // // //               {missingFields.map((field) => (
// // // //                 <li key={field}>{field}</li>
// // // //               ))}
// // // //             </ul>
// // // //             <p>Please fill in these fields before continuing.</p>
// // // //             <div className="ConfirmOverlayButtons">
// // // //               <button className="OverlayConfirmBtn" onClick={handleProceedToConfirmation}>
// // // //                 Next
// // // //               </button>
// // // //               <button className="OverlayCloseBtn" onClick={handleCancelMissingFields}>
// // // //                 Cancel
// // // //               </button>
// // // //             </div>
// // // //           </div>
// // // //         </div>
// // // //       )}

// // // //       {showConfirmation && (
// // // //         <div className="ConfirmOverlay">
// // // //           <div className="ConfirmOverlayContent">
// // // //             <h3>Confirm Status Change</h3>
// // // //             <p>
// // // //               This action will send the invoice receipt for the deposit taken for <strong> CA${convertedFields.depositamount}</strong> and also send the move details to the Crew-Prod with the invoice no <strong> {booking.LeadACVLRecordID}</strong>
// // // //             </p>
// // // //             <div className="ConfirmOverlayButtons">
// // // //               <button className="OverlayConfirmBtn" onClick={handleConfirm}>
// // // //                 Confirm
// // // //               </button>
// // // //               <button className="OverlayCloseBtn" onClick={handleCancelConfirmation}>
// // // //                 Cancel
// // // //               </button>
// // // //             </div>
// // // //           </div>
// // // //         </div>
// // // //       )}

// // // //       {!justSaved && !isCurrentStatusFinal && (
// // // //         <div className="flex gap-2" style={{ display: "flex", gap: "15px", alignItems: "center", justifyContent: "center" }}>
// // // //           <button
// // // //             onClick={handleSave}
// // // //             className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
// // // //             style={{ padding: "5px 10px", background: "gray", color: "#ffffff", borderRadius: "10px" }}
// // // //             disabled={isLoading}
// // // //           >
// // // //             Save
// // // //           </button>
// // // //           <button
// // // //             onClick={handleCancel}
// // // //             className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
// // // //             style={{ padding: "5px 10px", background: "gray", color: "#ffffff", borderRadius: "10px" }}
// // // //             disabled={isLoading}
// // // //           >
// // // //             Cancel
// // // //           </button>
// // // //         </div>
// // // //       )}
// // // //     </div>
// // // //   );
// // // // };

// // // // export default StatusChange;

// // // // // before the overlay


// //   import React, { useState, useEffect } from "react";

// //   let cachedLeadStatusOptions = null;
// //   let cachedSecondaryStatusOptions = null;
// //   let cachedPaymentMethods = null;

// //   const StatusChange = ({ booking, updateBooking, accessToken }) => {
// //     const [leadStatus, setLeadStatus] = useState("");
// //     const [reason, setReason] = useState(booking.LeadStatusChangeReason || "");
// //     const [followUpDate, setFollowUpDate] = useState(booking.FollowUpDate || "");
// //     const [convertedFields, setConvertedFields] = useState({
// //       dateOfPayment: booking.Converted_dateOfPayment || "",
// //       depositamount: booking.Converted_depositamount || "",
// //       method: booking.Converted_method || "",
// //       collectedBy: booking.Converted_collectedBy || "",
// //       transactionId: booking.Converted_transactionId || "",
// //       paidTowards: booking.Converted_paidTowards || "",
// //     });
// //     const [error, setError] = useState("");
// //     const [justSaved, setJustSaved] = useState(false);
// //     const [leadStatusOptions, setLeadStatusOptions] = useState([]);
// //     const [secondaryStatusOptions, setSecondaryStatusOptions] = useState({});
// //     const [paymentMethods, setPaymentMethods] = useState([]);
// //     const [showConfirmation, setShowConfirmation] = useState(false);
// //     const [isLoading, setIsLoading] = useState(false);
// //     const [showMissingFields, setShowMissingFields] = useState(false);
// //     const [missingFields, setMissingFields] = useState([]);
// //     const [showBookingResponse, setShowBookingResponse] = useState(false);
// //     const [bookingResponseData, setBookingResponseData] = useState(null);

// //     useEffect(() => {
// //       const loadStatusOptions = async () => {
// //         if (cachedLeadStatusOptions && cachedSecondaryStatusOptions && cachedPaymentMethods) {
// //           setLeadStatusOptions(cachedLeadStatusOptions);
// //           setSecondaryStatusOptions(cachedSecondaryStatusOptions);
// //           setPaymentMethods(cachedPaymentMethods);
// //           return;
// //         }

// //         try {
// //           const response = await fetch("https://salesjet-10097049716.catalystappsail.com/emailtemp1", {
// //             method: "GET",
// //             headers: {
// //               "Content-Type": "application/json",
// //               Authorization: `Bearer ${accessToken}`,
// //             },
// //           });

// //           if (!response.ok) {
// //             throw new Error("Failed to fetch status options");
// //           }

// //           const apiData = await response.json();
// //           if (apiData.status === "success" && apiData.data) {
// //             // Fix malformed JSON where arrays are represented as objects without keys
// //             const fixedDataString = apiData.data.replace(/:\{([^}]+)\}/g, ':[$1]');
// //             // Parse the fixed stringified data array
// //             const parsedDataArray = JSON.parse(fixedDataString);
// //             // Merge all objects in the array into a single options object
// //             const allOptions = {};
// //             parsedDataArray.forEach(obj => {
// //               Object.assign(allOptions, obj);
// //             });

// //             // Extract and sort lead status options
// //             const leadStatuses = allOptions.LeadStatus || [];
// //             const sortedStatuses = [...leadStatuses].sort();
// //             setLeadStatusOptions(sortedStatuses);
// //             cachedLeadStatusOptions = sortedStatuses;

// //             // Extract and sort payment methods
// //             const paymentMethodsList = allOptions.paymentMethods || [];
// //             const sortedPaymentMethods = [...paymentMethodsList].sort();
// //             setPaymentMethods(sortedPaymentMethods);
// //             cachedPaymentMethods = sortedPaymentMethods;

// //             // Group secondary status options by primary status
// //             const groupedOptions = {};
// //             sortedStatuses.forEach(status => {
// //               groupedOptions[status] = [];
// //             });
// //             const secondaryOptionsList = allOptions.secondaryStatusOptions || [];
// //             secondaryOptionsList.forEach(opt => {
// //               const firstWord = opt.split("-")[0].trim();
// //               if (sortedStatuses.includes(firstWord)) {
// //                 const statusKey = firstWord;
// //                 if (!groupedOptions[statusKey].includes(opt)) {
// //                   groupedOptions[statusKey].push(opt);
// //                 }
// //               }
// //             });
// //             setSecondaryStatusOptions(groupedOptions);
// //             cachedSecondaryStatusOptions = groupedOptions;
// //           } else {
// //             setError("No status options found in response");
// //           }
// //         } catch (error) {
// //           console.error("Error fetching status options", error);
// //           setError("Failed to load status options. Please try again.");
// //         }
// //       };

// //       loadStatusOptions();
// //     }, [accessToken]);

// //     useEffect(() => {
// //       if (justSaved) {
// //         return;
// //       }
// //       setLeadStatus("");
// //       setReason(booking.LeadStatusChangeReason || "");
// //       setFollowUpDate(booking.FollowUpDate || "");
// //       setConvertedFields({
// //         dateOfPayment: booking.Converted_dateOfPayment || "",
// //         depositamount: booking.Converted_depositamount || "",
// //         method: booking.Converted_method || "",
// //         collectedBy: booking.Converted_collectedBy || "",
// //         transactionId: booking.Converted_transactionId || "",
// //         paidTowards: booking.Converted_paidTowards || "",
// //       });
// //       setError("");
// //     }, [
// //       booking.LeadStatusChangeReason,
// //       booking.FollowUpDate,
// //       booking.Converted_dateOfPayment,
// //       booking.Converted_depositamount,
// //       booking.Converted_method,
// //       booking.Converted_collectedBy,
// //       booking.Converted_transactionId,
// //       booking.Converted_paidTowards,
// //       booking.Lead_Status,
// //       justSaved,
// //     ]);

// //     const handleStatusChange = (e) => {
// //       const newStatus = e.target.value;
// //       setLeadStatus(newStatus);

// //       if (!secondaryStatusOptions[newStatus]) {
// //         setReason("");
// //       }

// //       if (newStatus !== "Open") {
// //         setFollowUpDate("");
// //       }

// //       if (newStatus !== "Converted") {
// //         setConvertedFields({
// //           dateOfPayment: "",
// //           depositamount: "",
// //           method: "",
// //           collectedBy: "",
// //           transactionId: "",
// //           paidTowards: "",
// //         });
// //       }
// //     };

// //     const handleReasonChange = (e) => {
// //       setReason(e.target.value);
// //     };

// //     const handleFollowUpDateChange = (e) => {
// //       setFollowUpDate(e.target.value);
// //     };

// //     const handleConvertedFieldChange = (field, value) => {
// //       setConvertedFields((prev) => ({ ...prev, [field]: value }));
// //     };

// //     const validateFields = () => {
// //       if (!leadStatus) {
// //         return "Lead Status is required";
// //       }
// //       const hasReasonOptions = secondaryStatusOptions[leadStatus] && secondaryStatusOptions[leadStatus].length > 0;
// //       if (hasReasonOptions && !reason) {
// //         return "Reason is required";
// //       }
// //       if (leadStatus === "Converted") {
// //         for (const [key, value] of Object.entries(convertedFields)) {
// //           if (!value) {
// //             return `${key.replace(/([A-Z])/g, " $1").trim()} is required`;
// //           }
// //         }
// //       }
// //       return "";
// //     };

// //     const validateBookingData = () => {
// //       const requiredFields = {
// //         LeadProviderLeadId: booking.LeadProviderLeadId,
// //         Sales_Agent: booking.Sales_Agent,
// //         Move_Size: booking.Move_Size,
// //         Move_Date: booking.Move_Date,
// //         DeliveryDate: booking.DeliveryDate,
// //         FlexibleDeliveryDate: booking.FlexibleDeliveryDate,
// //         OriginCity: booking.OriginCity,
// //         DestinationCity: booking.DestinationCity,
// //         LeadACVLRecordID: booking.LeadACVLRecordID,
// //         Banner: booking.Banner,
// //         FromAddress: booking.FromAddress,
// //         ToAddress: booking.ToAddress,
// //         Move_Type: booking.Move_Type,
// //         Customer_Name: booking.Customer_Name,
// //         Email: booking.Email,
// //         Phone_Number: booking.Phone_Number,
// //         LongWalkAtOrigin: booking.LongWalkAtOrigin || "",
// //         LongWalkAtDestination: booking.LongWalkAtDestination || "",
// //         NoOfStaircasesAtOrigin: booking.NoOfStaircasesAtOrigin,
// //         NoOfStaircasesAtDestination: booking.NoOfStaircasesAtDestination,
// //         ServiceElevatoratOrigin: booking.ServiceElevatoratOrigin || 0,
// //         ServiceElevatoratDestination: booking.ServiceElevatoratDestination || 0,
// //         OriginPropertyType: booking.OriginPropertyType,
// //         DestinationPropertyType: booking.DestinationPropertyType,
// //         HeavyEquipments: booking.HeavyEquipments,
// //         NeedPackingServices: booking.NeedPackingServices,
// //         PackingSupplies: booking.PackingSupplies,
// //         ParkingAvailableAtOrigin: booking.ParkingAvailableAtOrigin || "",
// //         ParkingAvailableAtDestination: booking.ParkingAvailableAtDestination || "",
// //         DismantlingOfFurnitures: booking.DismantlingOfFurnitures,
// //         ToolsRequired: booking.ToolsRequired,
// //         Inventory_List: booking.Inventory_List,
// //       };

// //       const missing = [];
// //       for (const [key, value] of Object.entries(requiredFields)) {
// //         if (value === undefined || value === null || value === "") {
// //           missing.push(key.replace(/([A-Z])/g, " $1").trim());
// //         }
// //       }
// //       return missing;
// //     };

// //     const handleSave = async () => {
// //       const validationError = validateFields();
// //       if (validationError) {
// //         setError(validationError);
// //         return;
// //       }

// //       if (leadStatus === "Converted") {
// //         const missing = validateBookingData();
// //         if (missing.length > 0) {
// //           setMissingFields(missing);
// //           setShowMissingFields(true);
// //           return;
// //         }
// //         setShowConfirmation(true);
// //         return;
// //       }

// //       await performSave();
// //     };

// //     const handleProceedToConfirmation = () => {
// //       setShowMissingFields(false);
// //       setShowConfirmation(true);
// //     };

// //     const handleCancelMissingFields = () => {
// //       setShowMissingFields(false);
// //       setError("");
// //     };

// //     const performSave = async () => {
// //       setError("");
// //       setIsLoading(true);

// //       if (!booking?.ROWID || !booking?.LeadACVLRecordID) {
// //         setError("Missing required booking data (ROWID or LeadACVLRecordID).");
// //         setIsLoading(false);
// //         return;
// //       }

// //       const updatedData = [
// //         {
// //           ROWID: booking.ROWID,
// //           Lead_Status: leadStatus,
// //           LeadStatusChangeReason: reason || "",
// //           FollowUpDate: leadStatus === "Open" ? followUpDate : "",
// //           ...(leadStatus === "Converted" && {
// //             Converted_dateOfPayment: convertedFields.dateOfPayment || "",
// //             Converted_depositamount: convertedFields.depositamount || "",
// //             Converted_method: convertedFields.method || "",
// //             Converted_collectedBy: convertedFields.collectedBy || "",
// //             Converted_transactionId: convertedFields.transactionId || "",
// //             Converted_paidTowards: convertedFields.paidTowards || "",
// //           }),
// //         },
// //       ];

// //       try {
// //         console.log("Updating leads data:", updatedData);
// //         const leadsResponse = await fetch("https://salesjet-10097049716.catalystappsail.com/leadsdata", {
// //           method: "PUT",
// //           headers: {
// //             "Content-Type": "application/json",
// //             Authorization: `Bearer ${accessToken}`,
// //           },
// //           body: JSON.stringify(updatedData),
// //         });

// //         if (!leadsResponse.ok) {
// //           const errorText = await leadsResponse.text();
// //           throw new Error(`Leads data update failed: ${errorText} (Status: ${leadsResponse.status})`);
// //         }
// //         console.log("Leads data updated successfully");

// //         updateBooking("Lead_Status", leadStatus, {
// //           LeadStatusChangeReason: reason || "",
// //           FollowUpDate: leadStatus === "Open" ? followUpDate : "",
// //           ...(leadStatus === "Converted" && {
// //             Converted_dateOfPayment: convertedFields.dateOfPayment || "",
// //             Converted_depositamount: convertedFields.depositamount || "",
// //             Converted_method: convertedFields.method || "",
// //             Converted_collectedBy: convertedFields.collectedBy || "",
// //             Converted_transactionId: convertedFields.transactionId || "",
// //             Converted_paidTowards: convertedFields.paidTowards || "",
// //           }),
// //         });

// //         if (leadStatus === "Converted") {

// //           const bookingData = [
// //             {
// //               LeadACVLRecordID: booking.LeadACVLRecordID,
// //             },
// //           ];

// //           const depositAmount = parseFloat(convertedFields.depositamount) || 0;
// //           if (depositAmount <= 0) {
// //             throw new Error("Deposit amount must be greater than zero.");
// //           }

// //           const updateStatusPayload = [
// //             {
// //               ROWID: booking.ROWID,
// //               Status: "Booked",
// //             },
// //           ];

// //           const bookingResp = await fetch("https://salesjet-10097049716.catalystappsail.com/datatomovejet", {
// //             method: "POST",
// //             headers: {
// //               "Content-Type": "application/json",
// //               Authorization: `Bearer ${accessToken}`,
// //             },
// //             body: JSON.stringify(bookingData),
// //           });

// //           if (!bookingResp.ok) {
// //             const errorText = await bookingResp.text();
// //             throw new Error(`Booking data save failed: ${errorText} (Status: ${bookingResp.status})`);
// //           }

// //           const bookingRespData = await bookingResp.json();
// //           console.log("Booking data saved successfully:", bookingRespData);
// //           setBookingResponseData(bookingRespData);
// //           setShowBookingResponse(true);
// //           const [statusUpdateResponse] = await Promise.all([
// //             fetch("https://salesjet-10097049716.catalystappsail.com/leadsdata", {
// //               method: "PUT",
// //               headers: {
// //                 "Content-Type": "application/json",
// //                 Authorization: `Bearer ${accessToken}`,
// //               },
// //               body: JSON.stringify(updateStatusPayload),
// //             }).catch((err) => {
// //               throw new Error(`Status update API failed: ${err.message}`);
// //             }),
// //           ]);

// //           if (!statusUpdateResponse.ok) {
// //             const errorText = await statusUpdateResponse.text();
// //             throw new Error(`Status update failed: ${errorText} (Status: ${statusUpdateResponse.status})`);
// //           }
// //           console.log("Status updated successfully");

// //           updateBooking("Status", "Book Executed");
// //         }
// //         setJustSaved(true);
// //         setError("");
// //         console.log("Save completed successfully");
// //       } catch (error) {
// //         console.error("Error in performSave:", error);
// //         setError(`Failed to save changes: ${error.message}`);
// //         setJustSaved(false);
// //       } finally {
// //         setIsLoading(false);
// //         setShowConfirmation(false);
// //       }
// //     };

// //     const handleConfirm = async () => {
// //       setShowConfirmation(false);
// //       await performSave();
// //     };

// //     const handleCancelConfirmation = () => {
// //       setShowConfirmation(false);
// //     };

// //     const handleCloseBookingResponse = () => {
// //       setShowBookingResponse(false);
// //       setBookingResponseData(null);
// //     };

// //     const handleCancel = () => {
// //       setLeadStatus("");
// //       setReason(booking.LeadStatusChangeReason || "");
// //       setFollowUpDate(booking.FollowUpDate || "");
// //       setConvertedFields({
// //         dateOfPayment: booking.Converted_dateOfPayment || "",
// //         depositamount: booking.Converted_depositamount || "",
// //         method: booking.Converted_method || "",
// //         collectedBy: booking.Converted_collectedBy || "",
// //         transactionId: booking.Converted_transactionId || "",
// //         paidTowards: booking.Converted_paidTowards || "",
// //       });
// //       setError("");
// //       setJustSaved(false);
// //     };

// //     const displayedCurrentStatus = justSaved ? leadStatus : booking.Lead_Status || "None";
// //     const isStatusFinal = ["Converted"].includes(leadStatus);
// //     const isCurrentStatusFinal = justSaved
// //       ? ["Converted"].includes(leadStatus)
// //       : ["Converted"].includes(booking.Lead_Status);
// //     const reasonOptionsKey = leadStatus && leadStatus !== (booking.Lead_Status || "None")
// //       ? leadStatus
// //       : booking.Lead_Status || "None";

// //     return (
// //       <div className="status-change-section p-4" style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "5px" }}>
// //         {error && <div className="text-red-500 mb-2">{error}</div>}
// //         {isLoading && (
// //           <div className="LoadingOverlay">
// //             <div className="LoadingOverlayContent">
// //               <div className="Spinner"></div>
// //               <p>Processing...</p>
// //             </div>
// //           </div>
// //         )}

// //         <div
// //           className="mb-4"
// //           style={{
// //             padding: "10px",
// //             display: "flex",
// //             justifyContent: isCurrentStatusFinal ? "flex-start" : "space-between",
// //             alignItems: "center",
// //           }}
// //         >
// //           <div className={isCurrentStatusFinal ? "w-full" : "w-1/3"}>
// //             <strong>Current Status:</strong> {displayedCurrentStatus}
// //           </div>
// //           {!isCurrentStatusFinal && (
// //             <>
// //               <div className="w-1/6 text-center" style={{ fontSize: "30px" }}>
// //                 <span className="text-2xl">→</span>
// //               </div>
// //               <div className="w-1/2">
// //                 {!isStatusFinal && (
// //                   <div style={{ display: "flex" }}>
// //                     <label htmlFor="lead-status" className="block font-bold">
// //                       New Lead Status:
// //                     </label>
// //                     <select
// //                       id="lead-status"
// //                       value={leadStatus}
// //                       onChange={handleStatusChange}
// //                       className="border p-2 rounded w-full"
// //                       required
// //                     >
// //                       <option value="">Select Status</option>
// //                       {leadStatusOptions.map((status) => (
// //                         <option key={status} value={status}>
// //                           {status}
// //                         </option>
// //                       ))}
// //                     </select>
// //                   </div>
// //                 )}
// //                 {isStatusFinal && (
// //                   <div>
// //                     <label htmlFor="lead-status" className="block font-bold">
// //                       New Status:
// //                     </label>
// //                     {leadStatus}
// //                   </div>
// //                 )}
// //               </div>
// //             </>
// //           )}
// //         </div>

// //         <hr className="border-gray-300 mb-4" />

// //         <div
// //           className="grid grid-cols-2 gap-4 mb-4"
// //           style={{ padding: "10px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}
// //         >
// //           {secondaryStatusOptions[reasonOptionsKey] && secondaryStatusOptions[reasonOptionsKey].length > 0 && (
// //             <div style={{ display: "flex", flexDirection: "column" }}>
// //               <label htmlFor="reason" className="block font-bold">
// //                 Reason
// //               </label>
// //               <select
// //                 id="reason"
// //                 value={reason}
// //                 onChange={handleReasonChange}
// //                 className="border p-2 rounded w-full"
// //                 style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
// //                 required
// //               >
// //                 <option value="">Select Reason</option>
// //                 {secondaryStatusOptions[reasonOptionsKey].map((opt) => (
// //                   <option key={opt} value={opt}>
// //                     {opt}
// //                   </option>
// //                 ))}
// //               </select>
// //             </div>
// //           )}
// //         </div>

// //         {(leadStatus === "Converted" || booking.Lead_Status === "Converted") && (
// //           <div
// //             className="converted-fields grid grid-cols-2 gap-4 mb-4"
// //             style={{ padding: "10px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}
// //           >
// //             <div style={{ display: "flex", flexDirection: "column" }}>
// //               <label className="block font-bold">Date of Payment</label>
// //               <input
// //                 type="date"
// //                 value={convertedFields.dateOfPayment}
// //                 onChange={(e) => handleConvertedFieldChange("dateOfPayment", e.target.value)}
// //                 className="border p-2 rounded w-full"
// //                 style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
// //                 required
// //               />
// //             </div>
// //             <div style={{ display: "flex", flexDirection: "column" }}>
// //               <label className="block font-bold">Deposit Amount</label>
// //               <input
// //                 type="number"
// //                 value={convertedFields.depositamount}
// //                 onChange={(e) => handleConvertedFieldChange("depositamount", e.target.value)}
// //                 className="border p-2 rounded w-full"
// //                 style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
// //                 required
// //               />
// //             </div>
// //             <div style={{ display: "flex", flexDirection: "column" }}>
// //               <label className="block font-bold">Method</label>
// //               <select
// //                 value={convertedFields.method}
// //                 onChange={(e) => handleConvertedFieldChange("method", e.target.value)}
// //                 className="border p-2 rounded w-full"
// //                 style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
// //                 required
// //               >
// //                 <option value="">Select Payment Method</option>
// //                 {paymentMethods.map((method) => (
// //                   <option key={method} value={method}>
// //                     {method}
// //                   </option>
// //                 ))}
// //               </select>
// //             </div>
// //             <div style={{ display: "flex", flexDirection: "column" }}>
// //               <label className="block font-bold">Collected By</label>
// //               <input
// //                 type="text"
// //                 value={convertedFields.collectedBy}
// //                 onChange={(e) => handleConvertedFieldChange("collectedBy", e.target.value)}
// //                 className="border p-2 rounded w-full"
// //                 style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
// //                 required
// //               />
// //             </div>
// //             <div style={{ display: "flex", flexDirection: "column" }}>
// //               <label className="block font-bold">Transaction ID</label>
// //               <input
// //                 type="text"
// //                 value={convertedFields.transactionId}
// //                 onChange={(e) => handleConvertedFieldChange("transactionId", e.target.value)}
// //                 className="border p-2 rounded w-full"
// //                 style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
// //                 required
// //               />
// //             </div>
// //             <div style={{ display: "flex", flexDirection: "column" }}>
// //               <label className="block font-bold">Paid Towards</label>
// //               <input
// //                 type="text"
// //                 value={convertedFields.paidTowards}
// //                 onChange={(e) => handleConvertedFieldChange("paidTowards", e.target.value)}
// //                 className="border p-2 rounded w-full"
// //                 style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
// //                 placeholder="Deposit"
// //                 required
// //               />
// //             </div>
// //           </div>
// //         )}

// //         {showMissingFields && (
// //           <div className="ConfirmOverlay">
// //             <div className="ConfirmOverlayContent" style={{textAlign: "left"}}>
// //               <h3>Missing Required Fields</h3>
// //               <p>The following fields are required to proceed with the booking:</p>
// //               <ul className="list-disc pl-5">
// //                 {missingFields.map((field) => (
// //                   <li key={field}>{field}</li>
// //                 ))}
// //               </ul>
// //               <p>Please fill in these fields before continuing.</p>
// //               <div className="ConfirmOverlayButtons">
// //                 <button className="OverlayConfirmBtn" onClick={handleProceedToConfirmation}>
// //                   Next
// //                 </button>
// //                 <button className="OverlayCloseBtn" onClick={handleCancelMissingFields}>
// //                   Cancel
// //                 </button>
// //               </div>
// //             </div>
// //           </div>
// //         )}

// //         {showConfirmation && (
// //           <div className="ConfirmOverlay">
// //             <div className="ConfirmOverlayContent">
// //               <h3>Confirm Status Change</h3>
// //               <p>
// //                 This action will send the invoice receipt for the deposit taken for <strong> CA${convertedFields.depositamount}</strong> and also send the move details to the Crew-Prod with the invoice no <strong> {booking.LeadACVLRecordID}</strong>
// //               </p>
// //               <div className="ConfirmOverlayButtons">
// //                 <button className="OverlayConfirmBtn" onClick={handleConfirm}>
// //                   Confirm
// //                 </button>
// //                 <button className="OverlayCloseBtn" onClick={handleCancelConfirmation}>
// //                   Cancel
// //                 </button>
// //               </div>
// //             </div>
// //           </div>
// //         )}

// //         {showBookingResponse && bookingResponseData && (
// //           <div className="ConfirmOverlay">
// //             <div className="ConfirmOverlayContent" style={{textAlign: "left", maxWidth: "500px"}}>
// //               <h3>Booking Response</h3>
// //               <p>Booking data has been successfully sent to movejet and QB.</p>
// //               <pre style={{backgroundColor: "#f5f5f5", padding: "10px", borderRadius: "4px", overflow: "auto", maxHeight: "300px"}}>
// //                 {JSON.stringify(bookingResponseData, null, 2)}
// //               </pre>
// //               <div className="ConfirmOverlayButtons">
// //                 <button className="OverlayCloseBtn" onClick={handleCloseBookingResponse}>
// //                   Close
// //                 </button>
// //               </div>
// //             </div>
// //           </div>
// //         )}

// //         {!justSaved && !isCurrentStatusFinal && (
// //           <div className="flex gap-2" style={{ display: "flex", gap: "15px", alignItems: "center", justifyContent: "center" }}>
// //             <button
// //               onClick={handleSave}
// //               className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
// //               style={{ padding: "5px 10px", background: "gray", color: "#ffffff", borderRadius: "10px" }}
// //               disabled={isLoading}
// //             >
// //               Save
// //             </button>
// //             <button
// //               onClick={handleCancel}
// //               className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
// //               style={{ padding: "5px 10px", background: "gray", color: "#ffffff", borderRadius: "10px" }}
// //               disabled={isLoading}
// //             >
// //               Cancel
// //             </button>
// //           </div>
// //         )}
// //       </div>
// //     );
// //   };

// //   export default StatusChange;

// //   // after some correction made in the overlay

// import React, { useState, useEffect } from "react";

// let cachedLeadStatusOptions = null;
// let cachedSecondaryStatusOptions = null;
// let cachedPaymentMethods = null;

// const StatusChange = ({ booking, updateBooking, accessToken }) => {
//   const [leadStatus, setLeadStatus] = useState("");
//   const [reason, setReason] = useState(booking.LeadStatusChangeReason || "");
//   const [followUpDate, setFollowUpDate] = useState(booking.FollowUpDate || "");
//   const [convertedFields, setConvertedFields] = useState({
//     dateOfPayment: booking.Converted_dateOfPayment || "",
//     depositamount: booking.Converted_depositamount || "",
//     method: booking.Converted_method || "",
//     collectedBy: booking.Converted_collectedBy || "",
//     transactionId: booking.Converted_transactionId || "",
//     paidTowards: booking.Converted_paidTowards || "",
//   });
//   const [error, setError] = useState("");
//   const [justSaved, setJustSaved] = useState(false);
//   const [leadStatusOptions, setLeadStatusOptions] = useState([]);
//   const [secondaryStatusOptions, setSecondaryStatusOptions] = useState({});
//   const [paymentMethods, setPaymentMethods] = useState([]);
//   const [showConfirmation, setShowConfirmation] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [showMissingFields, setShowMissingFields] = useState(false);
//   const [missingFields, setMissingFields] = useState([]);
//   const [showBookingResponse, setShowBookingResponse] = useState(false);
//   const [bookingResponseData, setBookingResponseData] = useState(null);

//   useEffect(() => {
//     const loadStatusOptions = async () => {
//       if (cachedLeadStatusOptions && cachedSecondaryStatusOptions && cachedPaymentMethods) {
//         setLeadStatusOptions(cachedLeadStatusOptions);
//         setSecondaryStatusOptions(cachedSecondaryStatusOptions);
//         setPaymentMethods(cachedPaymentMethods);
//         return;
//       }

//       try {
//         const response = await fetch("https://salesjet-10097049716.catalystappsail.com/emailtemp1", {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${accessToken}`,
//           },
//         });

//         if (!response.ok) {
//           throw new Error("Failed to fetch status options");
//         }

//         const apiData = await response.json();
//         if (apiData.status === "success" && apiData.data) {
//           // Fix malformed JSON where arrays are represented as objects without keys
//           const fixedDataString = apiData.data.replace(/:\{([^}]+)\}/g, ':[$1]');
//           // Parse the fixed stringified data array
//           const parsedDataArray = JSON.parse(fixedDataString);
//           // Merge all objects in the array into a single options object
//           const allOptions = {};
//           parsedDataArray.forEach(obj => {
//             Object.assign(allOptions, obj);
//           });

//           // Extract and sort lead status options
//           const leadStatuses = allOptions.LeadStatus || [];
//           const sortedStatuses = [...leadStatuses].sort();
//           setLeadStatusOptions(sortedStatuses);
//           cachedLeadStatusOptions = sortedStatuses;

//           // Extract and sort payment methods
//           const paymentMethodsList = allOptions.paymentMethods || [];
//           const sortedPaymentMethods = [...paymentMethodsList].sort();
//           setPaymentMethods(sortedPaymentMethods);
//           cachedPaymentMethods = sortedPaymentMethods;

//           // Group secondary status options by primary status
//           const groupedOptions = {};
//           sortedStatuses.forEach(status => {
//             groupedOptions[status] = [];
//           });
//           const secondaryOptionsList = allOptions.secondaryStatusOptions || [];
//           secondaryOptionsList.forEach(opt => {
//             const firstWord = opt.split("-")[0].trim();
//             if (sortedStatuses.includes(firstWord)) {
//               const statusKey = firstWord;
//               if (!groupedOptions[statusKey].includes(opt)) {
//                 groupedOptions[statusKey].push(opt);
//               }
//             }
//           });
//           setSecondaryStatusOptions(groupedOptions);
//           cachedSecondaryStatusOptions = groupedOptions;
//         } else {
//           setError("No status options found in response");
//         }
//       } catch (error) {
//         console.error("Error fetching status options", error);
//         setError("Failed to load status options. Please try again.");
//       }
//     };

//     loadStatusOptions();
//   }, [accessToken]);

//   useEffect(() => {
//     if (justSaved) {
//       return;
//     }
//     setLeadStatus("");
//     setReason(booking.LeadStatusChangeReason || "");
//     setFollowUpDate(booking.FollowUpDate || "");
//     setConvertedFields({
//       dateOfPayment: booking.Converted_dateOfPayment || "",
//       depositamount: booking.Converted_depositamount || "",
//       method: booking.Converted_method || "",
//       collectedBy: booking.Converted_collectedBy || "",
//       transactionId: booking.Converted_transactionId || "",
//       paidTowards: booking.Converted_paidTowards || "",
//     });
//     setError("");
//   }, [
//     booking.LeadStatusChangeReason,
//     booking.FollowUpDate,
//     booking.Converted_dateOfPayment,
//     booking.Converted_depositamount,
//     booking.Converted_method,
//     booking.Converted_collectedBy,
//     booking.Converted_transactionId,
//     booking.Converted_paidTowards,
//     booking.Lead_Status,
//     justSaved,
//   ]);

//   const handleStatusChange = (e) => {
//     const newStatus = e.target.value;
//     setLeadStatus(newStatus);

//     if (!secondaryStatusOptions[newStatus]) {
//       setReason("");
//     }

//     if (newStatus !== "Open") {
//       setFollowUpDate("");
//     }

//     if (newStatus !== "Converted") {
//       setConvertedFields({
//         dateOfPayment: "",
//         depositamount: "",
//         method: "",
//         collectedBy: "",
//         transactionId: "",
//         paidTowards: "",
//       });
//     }
//   };

//   const handleReasonChange = (e) => {
//     setReason(e.target.value);
//   };

//   const handleFollowUpDateChange = (e) => {
//     setFollowUpDate(e.target.value);
//   };

//   const handleConvertedFieldChange = (field, value) => {
//     setConvertedFields((prev) => ({ ...prev, [field]: value }));
//   };

//   const validateFields = () => {
//     if (!leadStatus) {
//       return "Lead Status is required";
//     }
//     const hasReasonOptions = secondaryStatusOptions[leadStatus] && secondaryStatusOptions[leadStatus].length > 0;
//     if (hasReasonOptions && !reason) {
//       return "Reason is required";
//     }
//     if (leadStatus === "Converted") {
//       for (const [key, value] of Object.entries(convertedFields)) {
//         if (!value) {
//           return `${key.replace(/([A-Z])/g, " $1").trim()} is required`;
//         }
//       }
//     }
//     return "";
//   };

//   const validateBookingData = () => {
//     const requiredFields = {
//       LeadProviderLeadId: booking.LeadProviderLeadId,
//       Sales_Agent: booking.Sales_Agent,
//       Move_Size: booking.Move_Size,
//       Move_Date: booking.Move_Date,
//       DeliveryDate: booking.DeliveryDate,
//       FlexibleDeliveryDate: booking.FlexibleDeliveryDate,
//       OriginCity: booking.OriginCity,
//       DestinationCity: booking.DestinationCity,
//       LeadACVLRecordID: booking.LeadACVLRecordID,
//       Banner: booking.Banner,
//       FromAddress: booking.FromAddress,
//       ToAddress: booking.ToAddress,
//       Move_Type: booking.Move_Type,
//       Customer_Name: booking.Customer_Name,
//       Email: booking.Email,
//       Phone_Number: booking.Phone_Number,
//       LongWalkAtOrigin: booking.LongWalkAtOrigin || "",
//       LongWalkAtDestination: booking.LongWalkAtDestination || "",
//       NoOfStaircasesAtOrigin: booking.NoOfStaircasesAtOrigin,
//       NoOfStaircasesAtDestination: booking.NoOfStaircasesAtDestination,
//       ServiceElevatoratOrigin: booking.ServiceElevatoratOrigin || 0,
//       ServiceElevatoratDestination: booking.ServiceElevatoratDestination || 0,
//       OriginPropertyType: booking.OriginPropertyType,
//       DestinationPropertyType: booking.DestinationPropertyType,
//       HeavyEquipments: booking.HeavyEquipments,
//       NeedPackingServices: booking.NeedPackingServices,
//       PackingSupplies: booking.PackingSupplies,
//       ParkingAvailableAtOrigin: booking.ParkingAvailableAtOrigin || "",
//       ParkingAvailableAtDestination: booking.ParkingAvailableAtDestination || "",
//       DismantlingOfFurnitures: booking.DismantlingOfFurnitures,
//       ToolsRequired: booking.ToolsRequired,
//       Inventory_List: booking.Inventory_List,
//     };

//     const missing = [];
//     for (const [key, value] of Object.entries(requiredFields)) {
//       if (value === undefined || value === null || value === "") {
//         missing.push(key.replace(/([A-Z])/g, " $1").trim());
//       }
//     }
//     return missing;
//   };

//   const handleSave = async () => {
//     const validationError = validateFields();
//     if (validationError) {
//       setError(validationError);
//       return;
//     }

//     if (leadStatus === "Converted") {
//       const missing = validateBookingData();
//       if (missing.length > 0) {
//         setMissingFields(missing);
//         setShowMissingFields(true);
//         return;
//       }
//       setShowConfirmation(true);
//       return;
//     }

//     await performSave();
//   };

//   const handleProceedToConfirmation = () => {
//     setShowMissingFields(false);
//     setShowConfirmation(true);
//   };

//   const handleCancelMissingFields = () => {
//     setShowMissingFields(false);
//     setError("");
//   };

//   const performSave = async () => {
//     setError("");
//     setIsLoading(true);

//     if (!booking?.ROWID || !booking?.LeadACVLRecordID) {
//       setError("Missing required booking data (ROWID or LeadACVLRecordID).");
//       setIsLoading(false);
//       return;
//     }

//     const updatedData = [
//       {
//         ROWID: booking.ROWID,
//         Lead_Status: leadStatus,
//         LeadStatusChangeReason: reason || "",
//         FollowUpDate: leadStatus === "Open" ? followUpDate : "",
//         ...(leadStatus === "Converted" && {
//           Converted_dateOfPayment: convertedFields.dateOfPayment || "",
//           Converted_depositamount: convertedFields.depositamount || "",
//           Converted_method: convertedFields.method || "",
//           Converted_collectedBy: convertedFields.collectedBy || "",
//           Converted_transactionId: convertedFields.transactionId || "",
//           Converted_paidTowards: convertedFields.paidTowards || "",
//         }),
//       },
//     ];

//     try {
//       console.log("Updating leads data:", updatedData);
//       const leadsResponse = await fetch("https://salesjet-10097049716.catalystappsail.com/leadsdata", {
//         method: "PUT",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${accessToken}`,
//         },
//         body: JSON.stringify(updatedData),
//       });

//       if (!leadsResponse.ok) {
//         const errorText = await leadsResponse.text();
//         throw new Error(`Leads data update failed: ${errorText} (Status: ${leadsResponse.status})`);
//       }
//       console.log("Leads data updated successfully");

//       updateBooking("Lead_Status", leadStatus, {
//         LeadStatusChangeReason: reason || "",
//         FollowUpDate: leadStatus === "Open" ? followUpDate : "",
//         ...(leadStatus === "Converted" && {
//           Converted_dateOfPayment: convertedFields.dateOfPayment || "",
//           Converted_depositamount: convertedFields.depositamount || "",
//           Converted_method: convertedFields.method || "",
//           Converted_collectedBy: convertedFields.collectedBy || "",
//           Converted_transactionId: convertedFields.transactionId || "",
//           Converted_paidTowards: convertedFields.paidTowards || "",
//         }),
//       });

//       if (leadStatus === "Converted") {

//         const bookingData = [
//           {
//             LeadACVLRecordID: booking.LeadACVLRecordID,
//           },
//         ];

//         const depositAmount = parseFloat(convertedFields.depositamount) || 0;
//         if (depositAmount <= 0) {
//           throw new Error("Deposit amount must be greater than zero.");
//         }

//         const updateStatusPayload = [
//           {
//             ROWID: booking.ROWID,
//             Status: "Booked",
//           },
//         ];

//         const bookingResp = await fetch("https://salesjet-10097049716.catalystappsail.com/datatomovejet", {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${accessToken}`,
//           },
//           body: JSON.stringify(bookingData),
//         });

//         if (!bookingResp.ok) {
//           const errorText = await bookingResp.text();
//           throw new Error(`Booking data save failed: ${errorText} (Status: ${bookingResp.status})`);
//         }

//         const bookingRespData = await bookingResp.json();
//         console.log("Booking data saved successfully:", bookingRespData);
//         setBookingResponseData(bookingRespData);
//         setShowBookingResponse(true);
//         const [statusUpdateResponse] = await Promise.all([
//           fetch("https://salesjet-10097049716.catalystappsail.com/leadsdata", {
//             method: "PUT",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${accessToken}`,
//             },
//             body: JSON.stringify(updateStatusPayload),
//           }).catch((err) => {
//             throw new Error(`Status update API failed: ${err.message}`);
//           }),
//         ]);

//         if (!statusUpdateResponse.ok) {
//           const errorText = await statusUpdateResponse.text();
//           throw new Error(`Status update failed: ${errorText} (Status: ${statusUpdateResponse.status})`);
//         }
//         console.log("Status updated successfully");

//         updateBooking("Status", "Book Executed");
//       }
//       setJustSaved(true);
//       setError("");
//       console.log("Save completed successfully");
//     } catch (error) {
//       console.error("Error in performSave:", error);
//       setError(`Failed to save changes: ${error.message}`);
//       setJustSaved(false);
//     } finally {
//       setIsLoading(false);
//       setShowConfirmation(false);
//     }
//   };

//   const handleConfirm = async () => {
//     setShowConfirmation(false);
//     await performSave();
//   };

//   const handleCancelConfirmation = () => {
//     setShowConfirmation(false);
//   };

//   const handleCloseBookingResponse = () => {
//     setShowBookingResponse(false);
//     // setBookingResponseData(null);
//     // Ensure status persists by resetting justSaved only if needed; here we keep it true to maintain display
//   };

//   const handleCancel = () => {
//     setLeadStatus("");
//     setReason(booking.LeadStatusChangeReason || "");
//     setFollowUpDate(booking.FollowUpDate || "");
//     setConvertedFields({
//       dateOfPayment: booking.Converted_dateOfPayment || "",
//       depositamount: booking.Converted_depositamount || "",
//       method: booking.Converted_method || "",
//       collectedBy: booking.Converted_collectedBy || "",
//       transactionId: booking.Converted_transactionId || "",
//       paidTowards: booking.Converted_paidTowards || "",
//     });
//     setError("");
//     setJustSaved(false);
//   };

//   const getSuccessMessages = (data) => {
//     const messages = [];

//     // Movejet data
//     const movejetSuccess = data.booking && data.estimate && data.payment;
//     if (movejetSuccess) {
//       messages.push("Movejet data successful");
//     } else {
//       if (!data.booking) messages.push("Movejet booking failed");
//       if (!data.estimate) messages.push("Movejet estimate failed");
//       if (!data.payment) messages.push("Movejet payment failed");
//     }

//     // Sub contractor task
//     if (data.Task) {
//       messages.push("Sub contractor task successful");
//     } else {
//       messages.push("Sub contractor task failed");
//     }

//     // Estimate with seal
//     if (data.email) {
//       messages.push("Estimate with seal successful");
//     } else {
//       messages.push("Estimate with seal failed");
//     }

//     // Payment record in QB
//     if (data.qb) {
//       messages.push("Payment record in QB successful");
//     } else {
//       messages.push("Payment record in QB failed");
//     }

//     return messages;
//   };

//   const displayedCurrentStatus = justSaved ? leadStatus : booking.Lead_Status || "None";
//   const isStatusFinal = ["Converted"].includes(leadStatus);
//   const isCurrentStatusFinal = justSaved
//     ? ["Converted"].includes(leadStatus)
//     : ["Converted"].includes(booking.Lead_Status);
//   const reasonOptionsKey = leadStatus && leadStatus !== (booking.Lead_Status || "None")
//     ? leadStatus
//     : booking.Lead_Status || "None";

//   return (
//     <div className="status-change-section p-4" style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "5px" }}>
//       {error && <div className="text-red-500 mb-2">{error}</div>}
//       {isLoading && (
//         <div className="LoadingOverlay">
//           <div className="LoadingOverlayContent">
//             <div className="Spinner"></div>
//             <p>Processing...</p>
//           </div>
//         </div>
//       )}

//       <div
//         className="mb-4"
//         style={{
//           padding: "10px",
//           display: "flex",
//           justifyContent: isCurrentStatusFinal ? "flex-start" : "space-between",
//           alignItems: "center",
//         }}
//       >
//         <div className={isCurrentStatusFinal ? "w-full" : "w-1/3"}>
//           <strong>Current Status:</strong> {displayedCurrentStatus}
//         </div>
//         {!isCurrentStatusFinal && (
//           <>
//             <div className="w-1/6 text-center" style={{ fontSize: "30px" }}>
//               <span className="text-2xl">→</span>
//             </div>
//             <div className="w-1/2">
//               {!isStatusFinal && (
//                 <div style={{ display: "flex" }}>
//                   <label htmlFor="lead-status" className="block font-bold">
//                     New Lead Status:
//                   </label>
//                   <select
//                     id="lead-status"
//                     value={leadStatus}
//                     onChange={handleStatusChange}
//                     className="border p-2 rounded w-full"
//                     required
//                   >
//                     <option value="">Select Status</option>
//                     {leadStatusOptions.map((status) => (
//                       <option key={status} value={status}>
//                         {status}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//               )}
//               {isStatusFinal && (
//                 <div>
//                   <label htmlFor="lead-status" className="block font-bold">
//                     New Status:
//                   </label>
//                   {leadStatus}
//                 </div>
//               )}
//             </div>
//           </>
//         )}
//       </div>

//       <hr className="border-gray-300 mb-4" />

//       <div
//         className="grid grid-cols-2 gap-4 mb-4"
//         style={{ padding: "10px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}
//       >
//         {secondaryStatusOptions[reasonOptionsKey] && secondaryStatusOptions[reasonOptionsKey].length > 0 && (
//           <div style={{ display: "flex", flexDirection: "column" }}>
//             <label htmlFor="reason" className="block font-bold">
//               Reason
//             </label>
//             <select
//               id="reason"
//               value={reason}
//               onChange={handleReasonChange}
//               className="border p-2 rounded w-full"
//               style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
//               required
//             >
//               <option value="">Select Reason</option>
//               {secondaryStatusOptions[reasonOptionsKey].map((opt) => (
//                 <option key={opt} value={opt}>
//                   {opt}
//                 </option>
//               ))}
//             </select>
//           </div>
//         )}
//       </div>

//       {(leadStatus === "Converted" || booking.Lead_Status === "Converted") && (
//         <div
//           className="converted-fields grid grid-cols-2 gap-4 mb-4"
//           style={{ padding: "10px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}
//         >
//           <div style={{ display: "flex", flexDirection: "column" }}>
//             <label className="block font-bold">Date of Payment</label>
//             <input
//               type="date"
//               value={convertedFields.dateOfPayment}
//               onChange={(e) => handleConvertedFieldChange("dateOfPayment", e.target.value)}
//               className="border p-2 rounded w-full"
//               style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
//               required
//             />
//           </div>
//           <div style={{ display: "flex", flexDirection: "column" }}>
//             <label className="block font-bold">Deposit Amount</label>
//             <input
//               type="number"
//               value={convertedFields.depositamount}
//               onChange={(e) => handleConvertedFieldChange("depositamount", e.target.value)}
//               className="border p-2 rounded w-full"
//               style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
//               required
//             />
//           </div>
//           <div style={{ display: "flex", flexDirection: "column" }}>
//             <label className="block font-bold">Method</label>
//             <select
//               value={convertedFields.method}
//               onChange={(e) => handleConvertedFieldChange("method", e.target.value)}
//               className="border p-2 rounded w-full"
//               style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
//               required
//             >
//               <option value="">Select Payment Method</option>
//               {paymentMethods.map((method) => (
//                 <option key={method} value={method}>
//                   {method}
//                 </option>
//               ))}
//             </select>
//           </div>
//           <div style={{ display: "flex", flexDirection: "column" }}>
//             <label className="block font-bold">Collected By</label>
//             <input
//               type="text"
//               value={convertedFields.collectedBy}
//               onChange={(e) => handleConvertedFieldChange("collectedBy", e.target.value)}
//               className="border p-2 rounded w-full"
//               style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
//               required
//             />
//           </div>
//           <div style={{ display: "flex", flexDirection: "column" }}>
//             <label className="block font-bold">Transaction ID</label>
//             <input
//               type="text"
//               value={convertedFields.transactionId}
//               onChange={(e) => handleConvertedFieldChange("transactionId", e.target.value)}
//               className="border p-2 rounded w-full"
//               style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
//               required
//             />
//           </div>
//           <div style={{ display: "flex", flexDirection: "column" }}>
//             <label className="block font-bold">Paid Towards</label>
//             <input
//               type="text"
//               value={convertedFields.paidTowards}
//               onChange={(e) => handleConvertedFieldChange("paidTowards", e.target.value)}
//               className="border p-2 rounded w-full"
//               style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
//               placeholder="Deposit"
//               required
//             />
//           </div>
//         </div>
//       )}

//       {showMissingFields && (
//         <div className="ConfirmOverlay">
//           <div className="ConfirmOverlayContent" style={{textAlign: "left"}}>
//             <h3>Missing Required Fields</h3>
//             <p>The following fields are required to proceed with the booking:</p>
//             <ul className="list-disc pl-5">
//               {missingFields.map((field) => (
//                 <li key={field}>{field}</li>
//               ))}
//             </ul>
//             <p>Please fill in these fields before continuing.</p>
//             <div className="ConfirmOverlayButtons">
//               <button className="OverlayConfirmBtn" onClick={handleProceedToConfirmation}>
//                 Next
//               </button>
//               <button className="OverlayCloseBtn" onClick={handleCancelMissingFields}>
//                 Cancel
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {showConfirmation && (
//         <div className="ConfirmOverlay">
//           <div className="ConfirmOverlayContent">
//             <h3>Confirm Status Change</h3>
//             <p>
//               This action will send the invoice receipt for the deposit taken for <strong> CA${convertedFields.depositamount}</strong> and also send the move details to the Crew-Prod with the invoice no <strong> {booking.LeadACVLRecordID}</strong>
//             </p>
//             <div className="ConfirmOverlayButtons">
//               <button className="OverlayConfirmBtn" onClick={handleConfirm}>
//                 Confirm
//               </button>
//               <button className="OverlayCloseBtn" onClick={handleCancelConfirmation}>
//                 Cancel
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {showBookingResponse && bookingResponseData && (
//         <div className="ConfirmOverlay">
//           <div className="ConfirmOverlayContent" style={{textAlign: "left", maxWidth: "500px"}}>
//             <h3>Booking Response</h3>
//             {bookingResponseData.message && <p>{bookingResponseData.message}</p>}
//             <ul className="list-disc pl-5 mb-4">
//               {getSuccessMessages(bookingResponseData).map((msg, index) => (
//                 <li key={index} className={msg.includes("failed") ? "text-red-500" : "text-green-500"}>{msg}</li>
//               ))}
//             </ul>
//             <div className="ConfirmOverlayButtons">
//               <button className="OverlayCloseBtn" onClick={handleCloseBookingResponse}>
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {!justSaved && !isCurrentStatusFinal && (
//         <div className="flex gap-2" style={{ display: "flex", gap: "15px", alignItems: "center", justifyContent: "center" }}>
//           <button
//             onClick={handleSave}
//             className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
//             style={{ padding: "5px 10px", background: "gray", color: "#ffffff", borderRadius: "10px" }}
//             disabled={isLoading}
//           >
//             Save
//           </button>
//           <button
//             onClick={handleCancel}
//             className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
//             style={{ padding: "5px 10px", background: "gray", color: "#ffffff", borderRadius: "10px" }}
//             disabled={isLoading}
//           >
//             Cancel
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default StatusChange;
import React, { useState, useEffect } from "react";

let cachedLeadStatusOptions = null;
let cachedSecondaryStatusOptions = null;
let cachedPaymentMethods = null;

const StatusChange = ({ booking, updateBooking, accessToken }) => {
  const [leadStatus, setLeadStatus] = useState("");
  const [reason, setReason] = useState(booking.LeadStatusChangeReason || "");
  const [followUpDate, setFollowUpDate] = useState(booking.FollowUpDate || "");
  const [convertedFields, setConvertedFields] = useState({
    dateOfPayment: booking.Converted_dateOfPayment || "",
    depositamount: booking.Converted_depositamount || "",
    method: booking.Converted_method || "",
    collectedBy: booking.Converted_collectedBy || "",
    transactionId: booking.Converted_transactionId || "",
    paidTowards: booking.Converted_paidTowards || "",
  });
  const [error, setError] = useState("");
  const [justSaved, setJustSaved] = useState(false);
  const [leadStatusOptions, setLeadStatusOptions] = useState([]);
  const [secondaryStatusOptions, setSecondaryStatusOptions] = useState({});
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showMissingFields, setShowMissingFields] = useState(false);
  const [missingFields, setMissingFields] = useState([]);
  const [showBookingResponse, setShowBookingResponse] = useState(false);
  const [bookingResponseData, setBookingResponseData] = useState(null);

  useEffect(() => {
    const loadStatusOptions = async () => {
      if (cachedLeadStatusOptions && cachedSecondaryStatusOptions && cachedPaymentMethods) {
        setLeadStatusOptions(cachedLeadStatusOptions);
        setSecondaryStatusOptions(cachedSecondaryStatusOptions);
        setPaymentMethods(cachedPaymentMethods);
        return;
      }

      try {
        const response = await fetch("https://salesjet-10097049716.catalystappsail.com/emailtemp1", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch status options");
        }

        const apiData = await response.json();
        if (apiData.status === "success" && apiData.data) {
          // Fix malformed JSON where arrays are represented as objects without keys
          const fixedDataString = apiData.data.replace(/:\{([^}]+)\}/g, ':[$1]');
          // Parse the fixed stringified data array
          const parsedDataArray = JSON.parse(fixedDataString);
          // Merge all objects in the array into a single options object
          const allOptions = {};
          parsedDataArray.forEach(obj => {
            Object.assign(allOptions, obj);
          });

          // Extract and sort lead status options
          const leadStatuses = allOptions.LeadStatus || [];
          const sortedStatuses = [...leadStatuses].sort();
          setLeadStatusOptions(sortedStatuses);
          cachedLeadStatusOptions = sortedStatuses;

          // Extract and sort payment methods
          const paymentMethodsList = allOptions.paymentMethods || [];
          const sortedPaymentMethods = [...paymentMethodsList].sort();
          setPaymentMethods(sortedPaymentMethods);
          cachedPaymentMethods = sortedPaymentMethods;

          // Group secondary status options by primary status
          const groupedOptions = {};
          sortedStatuses.forEach(status => {
            groupedOptions[status] = [];
          });
          const secondaryOptionsList = allOptions.secondaryStatusOptions || [];
          secondaryOptionsList.forEach(opt => {
            const firstWord = opt.split("-")[0].trim();
            if (sortedStatuses.includes(firstWord)) {
              const statusKey = firstWord;
              if (!groupedOptions[statusKey].includes(opt)) {
                groupedOptions[statusKey].push(opt);
              }
            }
          });
          setSecondaryStatusOptions(groupedOptions);
          cachedSecondaryStatusOptions = groupedOptions;
        } else {
          setError("No status options found in response");
        }
      } catch (error) {
        console.error("Error fetching status options", error);
        setError("Failed to load status options. Please try again.");
      }
    };

    loadStatusOptions();
  }, [accessToken]);

  useEffect(() => {
    if (justSaved) {
      return;
    }
    setLeadStatus(booking.Lead_Status || "");
    setReason(booking.LeadStatusChangeReason || "");
    setFollowUpDate(booking.FollowUpDate || "");
    setConvertedFields({
      dateOfPayment: booking.Converted_dateOfPayment || "",
      depositamount: booking.Converted_depositamount || "",
      method: booking.Converted_method || "",
      collectedBy: booking.Converted_collectedBy || "",
      transactionId: booking.Converted_transactionId || "",
      paidTowards: booking.Converted_paidTowards || "",
    });
    setError("");
  }, [
    booking.LeadStatusChangeReason,
    booking.FollowUpDate,
    booking.Converted_dateOfPayment,
    booking.Converted_depositamount,
    booking.Converted_method,
    booking.Converted_collectedBy,
    booking.Converted_transactionId,
    booking.Converted_paidTowards,
    booking.Lead_Status,
    justSaved,
  ]);

  const handleStatusChange = (e) => {
    const newStatus = e.target.value;
    setLeadStatus(newStatus);

    if (!secondaryStatusOptions[newStatus]) {
      setReason("");
    }

    if (newStatus !== "Open") {
      setFollowUpDate("");
    }

    if (newStatus !== "Converted") {
      setConvertedFields({
        dateOfPayment: "",
        depositamount: "",
        method: "",
        collectedBy: "",
        transactionId: "",
        paidTowards: "",
      });
    }
  };

  const handleReasonChange = (e) => {
    setReason(e.target.value);
  };

  const handleFollowUpDateChange = (e) => {
    setFollowUpDate(e.target.value);
  };

  const handleConvertedFieldChange = (field, value) => {
    setConvertedFields((prev) => ({ ...prev, [field]: value }));
  };

  const validateFields = () => {
    if (!leadStatus) {
      return "Lead Status is required";
    }
    const hasReasonOptions = secondaryStatusOptions[leadStatus] && secondaryStatusOptions[leadStatus].length > 0;
    if (hasReasonOptions && !reason) {
      return "Reason is required";
    }
    if (leadStatus === "Converted") {
      for (const [key, value] of Object.entries(convertedFields)) {
        if (!value) {
          return `${key.replace(/([A-Z])/g, " $1").trim()} is required`;
        }
      }
    }
    return "";
  };

  const validateBookingData = () => {
    const requiredFields = {
      LeadProviderLeadId: booking.LeadProviderLeadId,
      Sales_Agent: booking.Sales_Agent,
      Move_Size: booking.Move_Size,
      Move_Date: booking.Move_Date,
      DeliveryDate: booking.DeliveryDate,
      FlexibleDeliveryDate: booking.FlexibleDeliveryDate,
      OriginCity: booking.OriginCity,
      DestinationCity: booking.DestinationCity,
      LeadACVLRecordID: booking.LeadACVLRecordID,
      Banner: booking.Banner,
      FromAddress: booking.FromAddress,
      ToAddress: booking.ToAddress,
      Move_Type: booking.Move_Type,
      Customer_Name: booking.Customer_Name,
      Email: booking.Email,
      Phone_Number: booking.Phone_Number,
      LongWalkAtOrigin: booking.LongWalkAtOrigin || "",
      LongWalkAtDestination: booking.LongWalkAtDestination || "",
      NoOfStaircasesAtOrigin: booking.NoOfStaircasesAtOrigin,
      NoOfStaircasesAtDestination: booking.NoOfStaircasesAtDestination,
      ServiceElevatoratOrigin: booking.ServiceElevatoratOrigin || 0,
      ServiceElevatoratDestination: booking.ServiceElevatoratDestination || 0,
      OriginPropertyType: booking.OriginPropertyType,
      DestinationPropertyType: booking.DestinationPropertyType,
      HeavyEquipments: booking.HeavyEquipments,
      NeedPackingServices: booking.NeedPackingServices,
      PackingSupplies: booking.PackingSupplies,
      ParkingAvailableAtOrigin: booking.ParkingAvailableAtOrigin || "",
      ParkingAvailableAtDestination: booking.ParkingAvailableAtDestination || "",
      DismantlingOfFurnitures: booking.DismantlingOfFurnitures,
      ToolsRequired: booking.ToolsRequired,
      Inventory_List: booking.Inventory_List,
    };

    const missing = [];
    for (const [key, value] of Object.entries(requiredFields)) {
      if (value === undefined || value === null || value === "") {
        missing.push(key.replace(/([A-Z])/g, " $1").trim());
      }
    }
    return missing;
  };

  const handleSave = async () => {
    const validationError = validateFields();
    if (validationError) {
      setError(validationError);
      return;
    }

    if (leadStatus === "Converted") {
      const missing = validateBookingData();
      if (missing.length > 0) {
        setMissingFields(missing);
        setShowMissingFields(true);
        return;
      }
      setShowConfirmation(true);
      return;
    }

    await performSave();
  };

  const handleProceedToConfirmation = () => {
    setShowMissingFields(false);
    setShowConfirmation(true);
  };

  const handleCancelMissingFields = () => {
    setShowMissingFields(false);
    setError("");
  };

  const performSave = async () => {
    setError("");
    setIsLoading(true);

    if (!booking?.ROWID || !booking?.LeadACVLRecordID) {
      setError("Missing required booking data (ROWID or LeadACVLRecordID).");
      setIsLoading(false);
      return;
    }

    const updatedData = [
      {
        ROWID: booking.ROWID,
        Lead_Status: leadStatus,
        LeadStatusChangeReason: reason || "",
        FollowUpDate: leadStatus === "Open" ? followUpDate : "",
        ...(leadStatus === "Converted" && {
          Converted_dateOfPayment: convertedFields.dateOfPayment || "",
          Converted_depositamount: convertedFields.depositamount || "",
          Converted_method: convertedFields.method || "",
          Converted_collectedBy: convertedFields.collectedBy || "",
          Converted_transactionId: convertedFields.transactionId || "",
          Converted_paidTowards: convertedFields.paidTowards || "",
        }),
      },
    ];

    try {
      console.log("Updating leads data:", updatedData);
      const leadsResponse = await fetch("https://salesjet-10097049716.catalystappsail.com/leadsdata", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(updatedData),
      });

      if (!leadsResponse.ok) {
        const errorText = await leadsResponse.text();
        throw new Error(`Leads data update failed: ${errorText} (Status: ${leadsResponse.status})`);
      }
      console.log("Leads data updated successfully");

      updateBooking("Lead_Status", leadStatus, {
        LeadStatusChangeReason: reason || "",
        FollowUpDate: leadStatus === "Open" ? followUpDate : "",
        ...(leadStatus === "Converted" && {
          Converted_dateOfPayment: convertedFields.dateOfPayment || "",
          Converted_depositamount: convertedFields.depositamount || "",
          Converted_method: convertedFields.method || "",
          Converted_collectedBy: convertedFields.collectedBy || "",
          Converted_transactionId: convertedFields.transactionId || "",
          Converted_paidTowards: convertedFields.paidTowards || "",
        }),
      });

      setJustSaved(true);
      setError("");

      if (leadStatus === "Converted") {
        const bookingData = [
          {
            LeadACVLRecordID: booking.LeadACVLRecordID,
          },
        ];

        const depositAmount = parseFloat(convertedFields.depositamount) || 0;
        if (depositAmount <= 0) {
          throw new Error("Deposit amount must be greater than zero.");
        }

        const updateStatusPayload = [
          {
            ROWID: booking.ROWID,
            Status: "Booked",
          },
        ];

        const bookingResp = await fetch("https://salesjet-10097049716.catalystappsail.com/datatomovejet", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify(bookingData),
        });

        if (!bookingResp.ok) {
          const errorText = await bookingResp.text();
          throw new Error(`Booking data save failed: ${errorText} (Status: ${bookingResp.status})`);
        }

        const bookingRespData = await bookingResp.json();
        console.log("Booking data saved successfully:", bookingRespData);
        setBookingResponseData(bookingRespData);
        setShowBookingResponse(true);

        const [statusUpdateResponse] = await Promise.all([
          fetch("https://salesjet-10097049716.catalystappsail.com/leadsdata", {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
            body: JSON.stringify(updateStatusPayload),
          }).catch((err) => {
            throw new Error(`Status update API failed: ${err.message}`);
          }),
        ]);

        if (!statusUpdateResponse.ok) {
          const errorText = await statusUpdateResponse.text();
          throw new Error(`Status update failed: ${errorText} (Status: ${statusUpdateResponse.status})`);
        }
        console.log("Status updated successfully");

        updateBooking("Status", "Book Executed");
      }
      console.log("Save completed successfully");
    } catch (error) {
      console.error("Error in performSave:", error);
      setError(`Failed to save changes: ${error.message}`);
      setJustSaved(false);
    } finally {
      setIsLoading(false);
      setShowConfirmation(false);
    }
  };

  const handleConfirm = async () => {
    setShowConfirmation(false);
    await performSave();
  };

  const handleCancelConfirmation = () => {
    setShowConfirmation(false);
  };

  const handleCloseBookingResponse = () => {
    setShowBookingResponse(false);
    // setBookingResponseData(null);
    // Ensure status persists by resetting justSaved only if needed; here we keep it true to maintain display
  };

  const handleCancel = () => {
    setLeadStatus("");
    setReason(booking.LeadStatusChangeReason || "");
    setFollowUpDate(booking.FollowUpDate || "");
    setConvertedFields({
      dateOfPayment: booking.Converted_dateOfPayment || "",
      depositamount: booking.Converted_depositamount || "",
      method: booking.Converted_method || "",
      collectedBy: booking.Converted_collectedBy || "",
      transactionId: booking.Converted_transactionId || "",
      paidTowards: booking.Converted_paidTowards || "",
    });
    setError("");
    setJustSaved(false);
  };

  const getSuccessMessages = (data) => {
    const messages = [];

    // Movejet data
    const movejetSuccess = data.booking && data.estimate && data.payment;
    if (movejetSuccess) {
      messages.push("Movejet data successful");
    } else {
      if (!data.booking) messages.push("Movejet booking failed");
      if (!data.estimate) messages.push("Movejet estimate failed");
      if (!data.payment) messages.push("Movejet payment failed");
    }

    // Sub contractor task
    if (data.Task) {
      messages.push("Sub contractor task successful");
    } else {
      messages.push("Sub contractor task failed");
    }

    // Estimate with seal
    if (data.email) {
      messages.push("Estimate with seal successful");
    } else {
      messages.push("Estimate with seal failed");
    }

    // Payment record in QB
    if (data.qb) {
      messages.push("Payment record in QB successful");
    } else {
      messages.push("Payment record in QB failed");
    }

    return messages;
  };

  const displayedCurrentStatus = justSaved ? leadStatus : booking.Lead_Status || "None";
  const isStatusFinal = ["Converted"].includes(leadStatus);
  const isCurrentStatusFinal = justSaved
    ? ["Converted"].includes(leadStatus)
    : ["Converted"].includes(booking.Lead_Status);
  const reasonOptionsKey = leadStatus && leadStatus !== (booking.Lead_Status || "None")
    ? leadStatus
    : booking.Lead_Status || "None";

  return (
    <div className="status-change-section p-4" style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "5px" }}>
      {error && <div className="text-red-500 mb-2">{error}</div>}
      {isLoading && (
        <div className="LoadingOverlay">
          <div className="LoadingOverlayContent">
            <div className="Spinner"></div>
            <p>Processing...</p>
          </div>
        </div>
      )}

      <div
        className="mb-4"
        style={{
          padding: "10px",
          display: "flex",
          justifyContent: isCurrentStatusFinal ? "flex-start" : "space-between",
          alignItems: "center",
        }}
      >
        <div className={isCurrentStatusFinal ? "w-full" : "w-1/3"}>
          <strong>Current Status:</strong> {displayedCurrentStatus}
        </div>
        {!isCurrentStatusFinal && (
          <>
            <div className="w-1/6 text-center" style={{ fontSize: "30px" }}>
              <span className="text-2xl">→</span>
            </div>
            <div className="w-1/2">
              {!isStatusFinal && (
                <div style={{ display: "flex" }}>
                  <label htmlFor="lead-status" className="block font-bold">
                    New Lead Status:
                  </label>
                  <select
                    id="lead-status"
                    value={leadStatus}
                    onChange={handleStatusChange}
                    className="border p-2 rounded w-full"
                    required
                  >
                    <option value="">Select Status</option>
                    {leadStatusOptions.map((status) => (
                      <option key={status} value={status}>
                        {status}
                      </option>
                    ))}
                  </select>
                </div>
              )}
              {isStatusFinal && (
                <div>
                  <label htmlFor="lead-status" className="block font-bold">
                    New Status:
                  </label>
                  {leadStatus}
                </div>
              )}
            </div>
          </>
        )}
      </div>

      <hr className="border-gray-300 mb-4" />

      <div
        className="grid grid-cols-2 gap-4 mb-4"
        style={{ padding: "10px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}
      >
        {secondaryStatusOptions[reasonOptionsKey] && secondaryStatusOptions[reasonOptionsKey].length > 0 && (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label htmlFor="reason" className="block font-bold">
              Reason
            </label>
            <select
              id="reason"
              value={reason}
              onChange={handleReasonChange}
              className="border p-2 rounded w-full"
              style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
              required
            >
              <option value="">Select Reason</option>
              {secondaryStatusOptions[reasonOptionsKey].map((opt) => (
                <option key={opt} value={opt}>
                  {opt}
                </option>
              ))}
            </select>
          </div>
        )}
      </div>

      {(leadStatus === "Converted" || booking.Lead_Status === "Converted") && (
        <div
          className="converted-fields grid grid-cols-2 gap-4 mb-4"
          style={{ padding: "10px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label className="block font-bold">Date of Payment</label>
            <input
              type="date"
              value={convertedFields.dateOfPayment}
              onChange={(e) => handleConvertedFieldChange("dateOfPayment", e.target.value)}
              className="border p-2 rounded w-full"
              style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
              required
            />
          </div>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label className="block font-bold">Deposit Amount</label>
            <input
              type="number"
              value={convertedFields.depositamount}
              onChange={(e) => handleConvertedFieldChange("depositamount", e.target.value)}
              className="border p-2 rounded w-full"
              style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
              required
            />
          </div>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label className="block font-bold">Method</label>
            <select
              value={convertedFields.method}
              onChange={(e) => handleConvertedFieldChange("method", e.target.value)}
              className="border p-2 rounded w-full"
              style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
              required
            >
              <option value="">Select Payment Method</option>
              {paymentMethods.map((method) => (
                <option key={method} value={method}>
                  {method}
                </option>
              ))}
            </select>
          </div>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label className="block font-bold">Collected By</label>
            <input
              type="text"
              value={convertedFields.collectedBy}
              onChange={(e) => handleConvertedFieldChange("collectedBy", e.target.value)}
              className="border p-2 rounded w-full"
              style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
              required
            />
          </div>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label className="block font-bold">Transaction ID</label>
            <input
              type="text"
              value={convertedFields.transactionId}
              onChange={(e) => handleConvertedFieldChange("transactionId", e.target.value)}
              className="border p-2 rounded w-full"
              style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
              required
            />
          </div>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label className="block font-bold">Paid Towards</label>
            <input
              type="text"
              value={convertedFields.paidTowards}
              onChange={(e) => handleConvertedFieldChange("paidTowards", e.target.value)}
              className="border p-2 rounded w-full"
              style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
              placeholder="Deposit"
              required
            />
          </div>
        </div>
      )}

      {showMissingFields && (
        <div className="ConfirmOverlay">
          <div className="ConfirmOverlayContent" style={{textAlign: "left"}}>
            <h3>Missing Required Fields</h3>
            <p>The following fields are required to proceed with the booking:</p>
            <ul className="list-disc pl-5">
              {missingFields.map((field) => (
                <li key={field}>{field}</li>
              ))}
            </ul>
            <p>Please fill in these fields before continuing.</p>
            <div className="ConfirmOverlayButtons">
              <button className="OverlayConfirmBtn" onClick={handleProceedToConfirmation}>
                Next
              </button>
              <button className="OverlayCloseBtn" onClick={handleCancelMissingFields}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {showConfirmation && (
        <div className="ConfirmOverlay">
          <div className="ConfirmOverlayContent">
            <h3>Confirm Status Change</h3>
            <p>
              This action will send the invoice receipt for the deposit taken for <strong> CA${convertedFields.depositamount}</strong> and also send the move details to the Crew-Prod with the invoice no <strong> {booking.LeadACVLRecordID}</strong>
            </p>
            <div className="ConfirmOverlayButtons">
              <button className="OverlayConfirmBtn" onClick={handleConfirm}>
                Confirm
              </button>
              <button className="OverlayCloseBtn" onClick={handleCancelConfirmation}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {showBookingResponse && bookingResponseData && (
        <div className="ConfirmOverlay">
          <div className="ConfirmOverlayContent" style={{textAlign: "left", maxWidth: "500px"}}>
            <h3>Booking Response</h3>
            {bookingResponseData.message && <p>{bookingResponseData.message}</p>}
            <ul className="list-disc pl-5 mb-4">
              {getSuccessMessages(bookingResponseData).map((msg, index) => (
                <li key={index} className={msg.includes("failed") ? "text-red-500" : "text-green-500"}>{msg}</li>
              ))}
            </ul>
            <div className="ConfirmOverlayButtons">
              <button className="OverlayCloseBtn" onClick={handleCloseBookingResponse}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {!justSaved && !isCurrentStatusFinal && (
        <div className="flex gap-2" style={{ display: "flex", gap: "15px", alignItems: "center", justifyContent: "center" }}>
          <button
            onClick={handleSave}
            className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
            style={{ padding: "5px 10px", background: "gray", color: "#ffffff", borderRadius: "10px" }}
            disabled={isLoading}
          >
            Save
          </button>
          <button
            onClick={handleCancel}
            className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
            style={{ padding: "5px 10px", background: "gray", color: "#ffffff", borderRadius: "10px" }}
            disabled={isLoading}
          >
            Cancel
          </button>
        </div>
      )}
    </div>
  );
};

export default StatusChange;